import { Modes } from "@builder/core/build/es/types/types";
import { Config } from "./hooks/useEditor/types";

export const demoConfig: Config = {
  mode: Modes.page,
  container: null,
  htmlOutputType: "html",
  pageData: {
    id: "1",
    title: "Home",
    slug: "Home",
    status: "publish",
    data: {
      items: [
        {
          type: "Section",
          value: {
            _styles: ["section"],
            items: [
              {
                type: "SectionItem",
                value: {
                  _styles: ["section-item"],
                  items: [
                    {
                      type: "Row",
                      value: {
                        _styles: ["row", "hide-row-borders", "padding-0"],
                        items: [
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "hlmzgmvnpqdthjveqzwetzvbgbcdggwwbqgs",
                                          text: '<p class="brz-fs-sm-im-24 brz-fs-lg-25 brz-ls-lg-m_1 brz-fw-lg-400 brz-lh-lg-1_6 brz-lh-sm-im-1_6 brz-lh-xs-im-1_6 brz-ff-libre_baskerville brz-fw-xs-im-400 brz-fw-sm-400 brz-ls-sm-m_1_5 brz-ls-xs-m_1_5 brz-text-xs-center brz-fs-xs-26"><em class="brz-cp-color2">Supreme</em><strong class="brz-cp-color3"><em>.</em></strong></p>',
                                        },
                                      },
                                    ],
                                    _id: "ijpkfaljjrhmeshddxrqoksfqsoshalbikev",
                                    marginTopSuffix: "px",
                                    marginTop: 0,
                                    margin: 0,
                                    marginSuffix: "px",
                                    marginBottomSuffix: "px",
                                    marginBottom: 0,
                                    tabletMarginTop: 0,
                                    tabletMargin: 0,
                                    tabletMarginSuffix: "px",
                                    tabletMarginBottom: 0,
                                    mobileMarginType: "grouped",
                                  },
                                },
                              ],
                              _id: "mudfjpfqobjfldiocoxuteybnsnhselvalxk",
                              width: 13.5,
                              tabsCurrentElement: "tabCurrentElement",
                              borderWidthType: "ungrouped",
                              borderRightWidth: 2,
                              tempBorderRightWidth: 2,
                              tempBorderTopWidth: 0,
                              tempBorderBottomWidth: 0,
                              tempBorderLeftWidth: 0,
                              borderWidth: 4,
                              borderStyle: "solid",
                              borderRadius: 0,
                              borderTopLeftRadius: 0,
                              borderTopRightRadius: 0,
                              borderBottomLeftRadius: 0,
                              borderBottomRightRadius: 0,
                              borderColorOpacity: 0.18,
                              borderColorPalette: "color7",
                              tabsColor: "tabOverlay",
                              tempBorderColorPalette: "color7",
                              borderTopWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              tempBorderTopLeftRadius: 0,
                              tempBorderTopRightRadius: 0,
                              tempBorderBottomLeftRadius: 0,
                              tempBorderBottomRightRadius: 0,
                              tabletPaddingRight: 10,
                              tabletPaddingLeft: 20,
                              mobilePaddingRight: 0,
                              mobilePaddingLeft: 10,
                              tabsState: "tabNormal",
                              borderColorHex: "#778a9b",
                              tempBorderColorOpacity: 0.18,
                              tabletWidth: 22,
                              mobileWidth: 98.3,
                              paddingTop: 0,
                              paddingTopSuffix: "px",
                              padding: 15,
                              paddingBottom: 0,
                              paddingBottomSuffix: "px",
                              verticalAlign: "center",
                              tabletBorderRightWidth: 0,
                              tempTabletBorderRightWidth: 0,
                              tempTabletBorderTopWidth: 0,
                              tempTabletBorderBottomWidth: 0,
                              tempTabletBorderLeftWidth: 0,
                              tabletBorderWidth: 0,
                              tabletBorderStyle: "",
                              tabletBorderRadius: 0,
                              tabletBorderTopLeftRadius: 0,
                              tabletBorderTopRightRadius: 0,
                              tabletBorderBottomLeftRadius: 0,
                              tabletBorderBottomRightRadius: 0,
                              tabletBorderColorOpacity: 0,
                              tabletBorderColorPalette: 0,
                              tabletPaddingLeftSuffix: "px",
                              tabletPadding: 15,
                              mobilePaddingRightSuffix: "px",
                              mobilePadding: 0,
                              mobileBorderRightWidth: 0,
                              tempMobileBorderRightWidth: 0,
                              tempMobileBorderTopWidth: 0,
                              tempMobileBorderBottomWidth: 0,
                              tempMobileBorderLeftWidth: 0,
                              mobileBorderWidth: 0,
                              mobileBorderStyle: "",
                              mobileBorderRadius: 0,
                              mobileBorderTopLeftRadius: 0,
                              mobileBorderTopRightRadius: 0,
                              mobileBorderBottomLeftRadius: 0,
                              mobileBorderBottomRightRadius: 0,
                              mobileBorderColorOpacity: 0,
                              mobileBorderColorPalette: 0,
                              mobileMarginBottom: 0,
                              mobileMarginBottomSuffix: "px",
                              mobileMargin: 10,
                            },
                          },
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Cloneable",
                                  value: {
                                    _styles: ["wrapper-clone", "wrapper-clone--button"],
                                    items: [
                                      {
                                        type: "Button",
                                        value: {
                                          _styles: ["button"],
                                          _id: "zpvbladwsqjlrnltsckfryvvbfgdpofpqqee",
                                          size: "small",
                                          fontSize: 14,
                                          paddingTB: 11,
                                          paddingTop: 11,
                                          paddingBottom: 11,
                                          tempPaddingTB: 11,
                                          tempPaddingTop: 11,
                                          tempPaddingBottom: 11,
                                          paddingRL: 0,
                                          paddingRight: 0,
                                          paddingLeft: 0,
                                          tempPaddingRL: 26,
                                          tempPaddingRight: 26,
                                          tempPaddingLeft: 26,
                                          borderRadius: 2,
                                          borderWidth: 0,
                                          fillType: "default",
                                          tempFillType: "filled",
                                          borderRadiusType: "",
                                          borderColorOpacity: 0,
                                          borderColorPalette: "",
                                          bgColorOpacity: 0,
                                          bgColorPalette: "",
                                          hoverBgColorOpacity: 0,
                                          hoverBorderColorOpacity: 0,
                                          colorPalette: "color7",
                                          colorOpacity: 1,
                                          text: "About",
                                          iconName: "",
                                          iconType: "",
                                          hoverColorPalette: "color3",
                                          hoverColorOpacity: 1,
                                          colorHex: "#778a9b",
                                          tempColorOpacity: 1,
                                          hoverColorHex: "#778a9b",
                                          fontFamily: "abeezee",
                                          lineHeight: 1.6,
                                          letterSpacing: 0,
                                          fontWeight: 400,
                                          fontStyle: "button",
                                          tabletSize: "small",
                                          tabletFontSize: 11,
                                          tabletPaddingTB: 11,
                                          tabletPaddingTop: 11,
                                          tabletPaddingBottom: 11,
                                          tempTabletPaddingTB: 11,
                                          tempTabletPaddingTop: 11,
                                          tempTabletPaddingBottom: 11,
                                          tabletPaddingRL: 0,
                                          tabletPaddingRight: 0,
                                          tabletPaddingLeft: 0,
                                          tempTabletPaddingRL: 26,
                                          tempTabletPaddingRight: 26,
                                          tempTabletPaddingLeft: 26,
                                          tabletBorderRadius: 2,
                                          mobileSize: "small",
                                          mobileFontSize: 11,
                                          mobilePaddingTB: 11,
                                          mobilePaddingTop: 11,
                                          mobilePaddingBottom: 11,
                                          tempMobilePaddingTB: 11,
                                          tempMobilePaddingTop: 11,
                                          tempMobilePaddingBottom: 11,
                                          mobilePaddingRL: 0,
                                          mobilePaddingRight: 0,
                                          mobilePaddingLeft: 0,
                                          tempMobilePaddingRL: 26,
                                          tempMobilePaddingRight: 26,
                                          tempMobilePaddingLeft: 26,
                                          mobileBorderRadius: 2,
                                          className: "",
                                          iconSize: "small",
                                          iconCustomSize: 16,
                                          iconPosition: "right",
                                          iconSpacing: 10,
                                          iconStrokeWidth: 1,
                                          smallIconSize: 16,
                                          mediumIconSize: 24,
                                          largeIconSize: 32,
                                          bgColorType: "solid",
                                          gradientActivePointer: "startPointer",
                                          gradientStartPointer: 0,
                                          gradientFinishPointer: 100,
                                          gradientType: "linear",
                                          gradientLinearDegree: 90,
                                          gradientRadialDegree: 90,
                                          hoverBgColorType: "solid",
                                          hoverGradientActivePointer: "startPointer",
                                          hoverGradientStartPointer: 0,
                                          hoverGradientFinishPointer: 100,
                                          hoverGradientType: "linear",
                                          hoverGradientLinearDegree: 90,
                                          hoverGradientRadialDegree: 90,
                                          bgColorHex: "#239ddb",
                                          tempBgColorOpacity: 1,
                                          tempBgColorPalette: "color3",
                                          hoverBgColorHex: "#239ddb",
                                          hoverBgColorPalette: "color3",
                                          tempHoverBgColorOpacity: 0.8,
                                          tempHoverBgColorPalette: "color3",
                                          gradientColorHex: "#009900",
                                          gradientColorOpacity: 0.8,
                                          gradientColorPalette: "",
                                          tempGradientColorOpacity: 0.8,
                                          tempGradientColorPalette: "",
                                          hoverGradientColorHex: "#009900",
                                          hoverGradientColorOpacity: 0,
                                          hoverGradientColorPalette: "",
                                          tempHoverGradientColorOpacity: 0.8,
                                          tempHoverGradientColorPalette: "",
                                          tempColorPalette: "color8",
                                          tempHoverColorOpacity: 1,
                                          tempHoverColorPalette: "color8",
                                          borderColorHex: "#239ddb",
                                          tempBorderColorOpacity: 1,
                                          tempBorderColorPalette: "color3",
                                          hoverBorderColorHex: "#239ddb",
                                          hoverBorderColorPalette: "color3",
                                          tempHoverBorderColorOpacity: 0.8,
                                          tempHoverBorderColorPalette: "color3",
                                          smallFontSize: 11,
                                          mediumFontSize: 12,
                                          largeFontSize: 13,
                                          padding: 14,
                                          tempPadding: 14,
                                          smallPaddingY: 11,
                                          smallPaddingX: 26,
                                          mediumPaddingY: 14,
                                          mediumPaddingX: 42,
                                          largePaddingY: 19,
                                          largePaddingX: 44,
                                          tempBorderRadiusType: "square",
                                          borderTopLeftRadius: 2,
                                          borderTopRightRadius: 2,
                                          borderBottomRightRadius: 2,
                                          borderBottomLeftRadius: 2,
                                          tempBorderRadius: 2,
                                          tempBorderTopLeftRadius: 2,
                                          tempBorderTopRightRadius: 2,
                                          tempBorderBottomRightRadius: 2,
                                          tempBorderBottomLeftRadius: 2,
                                          hoverBorderRadius: 2,
                                          hoverBorderTopLeftRadius: 2,
                                          hoverBorderTopRightRadius: 2,
                                          hoverBorderBottomRightRadius: 2,
                                          hoverBorderBottomLeftRadius: 2,
                                          tempHoverBorderRadius: 2,
                                          tempHoverBorderTopLeftRadius: 2,
                                          tempHoverBorderTopRightRadius: 2,
                                          tempHoverBorderBottomRightRadius: 2,
                                          tempHoverBorderBottomLeftRadius: 2,
                                          tempBorderWidth: 2,
                                          borderStyle: "solid",
                                          boxShadow: 0,
                                          boxShadowColorHex: "#000000",
                                          boxShadowColorOpacity: 0,
                                          boxShadowColorPalette: 0,
                                          boxShadowBlur: 0,
                                          boxShadowSpread: 0,
                                          boxShadowVertical: 0,
                                          boxShadowHorizontal: 0,
                                          tempBoxShadowColorPalette: "",
                                          tempBoxShadowColorOpacity: 1,
                                          customCSS: "",
                                          tabletPadding: 11,
                                          tempTabletPadding: 11,
                                          tabletFontStyle: "button",
                                          tabletFontWeight: 700,
                                          tabletLineHeight: 1.8,
                                          tabletLetterSpacing: 1,
                                          tempTabletBorderRadius: 2,
                                          mobilePadding: 11,
                                          tempMobilePadding: 11,
                                          mobileFontStyle: "button",
                                          mobileFontWeight: 700,
                                          mobileLineHeight: 1.8,
                                          mobileLetterSpacing: 1,
                                          tempMobileBorderRadius: 2,
                                          linkType: "anchor",
                                          linkAnchor: "zeqfcpwrgxdeznyzyujlahaabdkiljhnozbe",
                                          tabsState: "",
                                          tabsColor: "",
                                          tempBoxShadowBlur: 0,
                                          tempBoxShadowSpread: 0,
                                          tempBoxShadowVertical: 0,
                                          tempBoxShadowHorizontal: 0,
                                        },
                                      },
                                      {
                                        type: "Button",
                                        value: {
                                          _styles: ["button"],
                                          _id: "ypnhyuyifkgfbyokiszhurqturprbmdtrzox",
                                          size: "small",
                                          fontSize: 14,
                                          paddingTB: 11,
                                          paddingTop: 11,
                                          paddingBottom: 11,
                                          tempPaddingTB: 11,
                                          tempPaddingTop: 11,
                                          tempPaddingBottom: 11,
                                          paddingRL: 0,
                                          paddingRight: 0,
                                          paddingLeft: 0,
                                          tempPaddingRL: 26,
                                          tempPaddingRight: 26,
                                          tempPaddingLeft: 26,
                                          borderRadius: 2,
                                          borderWidth: 0,
                                          fillType: "default",
                                          tempFillType: "filled",
                                          borderRadiusType: "",
                                          borderColorOpacity: 0,
                                          borderColorPalette: "",
                                          bgColorOpacity: 0,
                                          bgColorPalette: "",
                                          hoverBgColorOpacity: 0,
                                          hoverBorderColorOpacity: 0,
                                          colorPalette: "color7",
                                          colorOpacity: 1,
                                          text: "Services",
                                          iconName: "",
                                          iconType: "",
                                          hoverColorPalette: "color3",
                                          hoverColorOpacity: 1,
                                          colorHex: "#778a9b",
                                          tempColorOpacity: 1,
                                          hoverColorHex: "#778a9b",
                                          fontFamily: "abeezee",
                                          lineHeight: 1.6,
                                          letterSpacing: 0,
                                          fontWeight: 400,
                                          fontStyle: "button",
                                          tabletSize: "small",
                                          tabletFontSize: 11,
                                          tabletPaddingTB: 11,
                                          tabletPaddingTop: 11,
                                          tabletPaddingBottom: 11,
                                          tempTabletPaddingTB: 11,
                                          tempTabletPaddingTop: 11,
                                          tempTabletPaddingBottom: 11,
                                          tabletPaddingRL: 0,
                                          tabletPaddingRight: 0,
                                          tabletPaddingLeft: 0,
                                          tempTabletPaddingRL: 26,
                                          tempTabletPaddingRight: 26,
                                          tempTabletPaddingLeft: 26,
                                          tabletBorderRadius: 2,
                                          mobileSize: "small",
                                          mobileFontSize: 11,
                                          mobilePaddingTB: 11,
                                          mobilePaddingTop: 11,
                                          mobilePaddingBottom: 11,
                                          tempMobilePaddingTB: 11,
                                          tempMobilePaddingTop: 11,
                                          tempMobilePaddingBottom: 11,
                                          mobilePaddingRL: 0,
                                          mobilePaddingRight: 0,
                                          mobilePaddingLeft: 0,
                                          tempMobilePaddingRL: 26,
                                          tempMobilePaddingRight: 26,
                                          tempMobilePaddingLeft: 26,
                                          mobileBorderRadius: 2,
                                          linkType: "anchor",
                                          linkAnchor: "pacwvjuxmpbjcozcfwpjffuerrbvmaeiyrry",
                                          className: "",
                                          iconSize: "small",
                                          iconCustomSize: 16,
                                          iconPosition: "right",
                                          iconSpacing: 10,
                                          iconStrokeWidth: 1,
                                          smallIconSize: 16,
                                          mediumIconSize: 24,
                                          largeIconSize: 32,
                                          bgColorType: "solid",
                                          gradientActivePointer: "startPointer",
                                          gradientStartPointer: 0,
                                          gradientFinishPointer: 100,
                                          gradientType: "linear",
                                          gradientLinearDegree: 90,
                                          gradientRadialDegree: 90,
                                          hoverBgColorType: "solid",
                                          hoverGradientActivePointer: "startPointer",
                                          hoverGradientStartPointer: 0,
                                          hoverGradientFinishPointer: 100,
                                          hoverGradientType: "linear",
                                          hoverGradientLinearDegree: 90,
                                          hoverGradientRadialDegree: 90,
                                          bgColorHex: "#239ddb",
                                          tempBgColorOpacity: 1,
                                          tempBgColorPalette: "color3",
                                          hoverBgColorHex: "#239ddb",
                                          hoverBgColorPalette: "color3",
                                          tempHoverBgColorOpacity: 0.8,
                                          tempHoverBgColorPalette: "color3",
                                          gradientColorHex: "#009900",
                                          gradientColorOpacity: 0.8,
                                          gradientColorPalette: "",
                                          tempGradientColorOpacity: 0.8,
                                          tempGradientColorPalette: "",
                                          hoverGradientColorHex: "#009900",
                                          hoverGradientColorOpacity: 0,
                                          hoverGradientColorPalette: "",
                                          tempHoverGradientColorOpacity: 0.8,
                                          tempHoverGradientColorPalette: "",
                                          tempColorPalette: "color8",
                                          tempHoverColorOpacity: 1,
                                          tempHoverColorPalette: "color8",
                                          borderColorHex: "#239ddb",
                                          tempBorderColorOpacity: 1,
                                          tempBorderColorPalette: "color3",
                                          hoverBorderColorHex: "#239ddb",
                                          hoverBorderColorPalette: "color3",
                                          tempHoverBorderColorOpacity: 0.8,
                                          tempHoverBorderColorPalette: "color3",
                                          smallFontSize: 11,
                                          mediumFontSize: 12,
                                          largeFontSize: 13,
                                          padding: 14,
                                          tempPadding: 14,
                                          smallPaddingY: 11,
                                          smallPaddingX: 26,
                                          mediumPaddingY: 14,
                                          mediumPaddingX: 42,
                                          largePaddingY: 19,
                                          largePaddingX: 44,
                                          tempBorderRadiusType: "square",
                                          borderTopLeftRadius: 2,
                                          borderTopRightRadius: 2,
                                          borderBottomRightRadius: 2,
                                          borderBottomLeftRadius: 2,
                                          tempBorderRadius: 2,
                                          tempBorderTopLeftRadius: 2,
                                          tempBorderTopRightRadius: 2,
                                          tempBorderBottomRightRadius: 2,
                                          tempBorderBottomLeftRadius: 2,
                                          hoverBorderRadius: 2,
                                          hoverBorderTopLeftRadius: 2,
                                          hoverBorderTopRightRadius: 2,
                                          hoverBorderBottomRightRadius: 2,
                                          hoverBorderBottomLeftRadius: 2,
                                          tempHoverBorderRadius: 2,
                                          tempHoverBorderTopLeftRadius: 2,
                                          tempHoverBorderTopRightRadius: 2,
                                          tempHoverBorderBottomRightRadius: 2,
                                          tempHoverBorderBottomLeftRadius: 2,
                                          tempBorderWidth: 2,
                                          borderStyle: "solid",
                                          boxShadow: 0,
                                          boxShadowColorHex: "#000000",
                                          boxShadowColorOpacity: 0,
                                          boxShadowColorPalette: 0,
                                          boxShadowBlur: 0,
                                          boxShadowSpread: 0,
                                          boxShadowVertical: 0,
                                          boxShadowHorizontal: 0,
                                          tempBoxShadowColorPalette: "",
                                          tempBoxShadowColorOpacity: 1,
                                          customCSS: "",
                                          tabletPadding: 11,
                                          tempTabletPadding: 11,
                                          tabletFontStyle: "button",
                                          tabletFontWeight: 700,
                                          tabletLineHeight: 1.8,
                                          tabletLetterSpacing: 1,
                                          tempTabletBorderRadius: 2,
                                          mobilePadding: 11,
                                          tempMobilePadding: 11,
                                          mobileFontStyle: "button",
                                          mobileFontWeight: 700,
                                          mobileLineHeight: 1.8,
                                          mobileLetterSpacing: 1,
                                          tempMobileBorderRadius: 2,
                                          fontFamilyType: "google",
                                          families: {
                                            fontFamily: "montserrat",
                                          },
                                          paddingSuffix: "px",
                                          paddingTopSuffix: "px",
                                          paddingRightSuffix: "px",
                                          paddingBottomSuffix: "px",
                                          paddingLeftSuffix: "px",
                                          tempBorderStyle: "solid",
                                          borderWidthType: "grouped",
                                          borderTopWidth: 2,
                                          borderRightWidth: 2,
                                          borderBottomWidth: 2,
                                          borderLeftWidth: 2,
                                          tempBorderTopWidth: 2,
                                          tempBorderRightWidth: 2,
                                          tempBorderBottomWidth: 2,
                                          tempBorderLeftWidth: 2,
                                          tempBoxShadow: "on",
                                          tempBoxShadowBlur: 0,
                                          tempBoxShadowSpread: 0,
                                          tempBoxShadowVertical: 0,
                                          tempBoxShadowHorizontal: 0,
                                          hoverTransition: 50,
                                          tabletPaddingSuffix: "px",
                                          tabletPaddingTopSuffix: "px",
                                          tabletPaddingRightSuffix: "px",
                                          tabletPaddingBottomSuffix: "px",
                                          tabletPaddingLeftSuffix: "px",
                                          mobilePaddingSuffix: "px",
                                          mobilePaddingTopSuffix: "px",
                                          mobilePaddingRightSuffix: "px",
                                          mobilePaddingBottomSuffix: "px",
                                          mobilePaddingLeftSuffix: "px",
                                          tempMobileBoxShadowHorizontal: null,
                                        },
                                      },
                                      {
                                        type: "Button",
                                        value: {
                                          _styles: ["button"],
                                          _id: "diwcrobbyxkpupqggyrpvkioxbuvdaxqkcgk",
                                          size: "small",
                                          fontSize: 14,
                                          paddingTB: 11,
                                          paddingTop: 11,
                                          paddingBottom: 11,
                                          tempPaddingTB: 11,
                                          tempPaddingTop: 11,
                                          tempPaddingBottom: 11,
                                          paddingRL: 0,
                                          paddingRight: 0,
                                          paddingLeft: 0,
                                          tempPaddingRL: 26,
                                          tempPaddingRight: 26,
                                          tempPaddingLeft: 26,
                                          borderRadius: 2,
                                          borderWidth: 0,
                                          fillType: "default",
                                          tempFillType: "filled",
                                          borderRadiusType: "",
                                          borderColorOpacity: 0,
                                          borderColorPalette: "",
                                          bgColorOpacity: 0,
                                          bgColorPalette: "",
                                          hoverBgColorOpacity: 0,
                                          hoverBorderColorOpacity: 0,
                                          colorPalette: "color7",
                                          colorOpacity: 1,
                                          text: "Contact",
                                          iconName: "",
                                          iconType: "",
                                          hoverColorPalette: "color3",
                                          hoverColorOpacity: 1,
                                          colorHex: "#778a9b",
                                          tempColorOpacity: 1,
                                          hoverColorHex: "#778a9b",
                                          fontFamily: "abeezee",
                                          lineHeight: 1.6,
                                          letterSpacing: 0,
                                          fontWeight: 400,
                                          fontStyle: "button",
                                          tabletSize: "small",
                                          tabletFontSize: 11,
                                          tabletPaddingTB: 11,
                                          tabletPaddingTop: 11,
                                          tabletPaddingBottom: 11,
                                          tempTabletPaddingTB: 11,
                                          tempTabletPaddingTop: 11,
                                          tempTabletPaddingBottom: 11,
                                          tabletPaddingRL: 0,
                                          tabletPaddingRight: 0,
                                          tabletPaddingLeft: 0,
                                          tempTabletPaddingRL: 26,
                                          tempTabletPaddingRight: 26,
                                          tempTabletPaddingLeft: 26,
                                          tabletBorderRadius: 2,
                                          mobileSize: "small",
                                          mobileFontSize: 11,
                                          mobilePaddingTB: 11,
                                          mobilePaddingTop: 11,
                                          mobilePaddingBottom: 11,
                                          tempMobilePaddingTB: 11,
                                          tempMobilePaddingTop: 11,
                                          tempMobilePaddingBottom: 11,
                                          mobilePaddingRL: 0,
                                          mobilePaddingRight: 0,
                                          mobilePaddingLeft: 0,
                                          tempMobilePaddingRL: 26,
                                          tempMobilePaddingRight: 26,
                                          tempMobilePaddingLeft: 26,
                                          mobileBorderRadius: 2,
                                          className: "",
                                          iconSize: "small",
                                          iconCustomSize: 16,
                                          iconPosition: "right",
                                          iconSpacing: 10,
                                          iconStrokeWidth: 1,
                                          smallIconSize: 16,
                                          mediumIconSize: 24,
                                          largeIconSize: 32,
                                          bgColorType: "solid",
                                          gradientActivePointer: "startPointer",
                                          gradientStartPointer: 0,
                                          gradientFinishPointer: 100,
                                          gradientType: "linear",
                                          gradientLinearDegree: 90,
                                          gradientRadialDegree: 90,
                                          hoverBgColorType: "solid",
                                          hoverGradientActivePointer: "startPointer",
                                          hoverGradientStartPointer: 0,
                                          hoverGradientFinishPointer: 100,
                                          hoverGradientType: "linear",
                                          hoverGradientLinearDegree: 90,
                                          hoverGradientRadialDegree: 90,
                                          bgColorHex: "#239ddb",
                                          tempBgColorOpacity: 1,
                                          tempBgColorPalette: "color3",
                                          hoverBgColorHex: "#239ddb",
                                          hoverBgColorPalette: "color3",
                                          tempHoverBgColorOpacity: 0.8,
                                          tempHoverBgColorPalette: "color3",
                                          gradientColorHex: "#009900",
                                          gradientColorOpacity: 0.8,
                                          gradientColorPalette: "",
                                          tempGradientColorOpacity: 0.8,
                                          tempGradientColorPalette: "",
                                          hoverGradientColorHex: "#009900",
                                          hoverGradientColorOpacity: 0,
                                          hoverGradientColorPalette: "",
                                          tempHoverGradientColorOpacity: 0.8,
                                          tempHoverGradientColorPalette: "",
                                          tempColorPalette: "color8",
                                          tempHoverColorOpacity: 1,
                                          tempHoverColorPalette: "color8",
                                          borderColorHex: "#239ddb",
                                          tempBorderColorOpacity: 1,
                                          tempBorderColorPalette: "color3",
                                          hoverBorderColorHex: "#239ddb",
                                          hoverBorderColorPalette: "color3",
                                          tempHoverBorderColorOpacity: 0.8,
                                          tempHoverBorderColorPalette: "color3",
                                          smallFontSize: 11,
                                          mediumFontSize: 12,
                                          largeFontSize: 13,
                                          padding: 14,
                                          tempPadding: 14,
                                          smallPaddingY: 11,
                                          smallPaddingX: 26,
                                          mediumPaddingY: 14,
                                          mediumPaddingX: 42,
                                          largePaddingY: 19,
                                          largePaddingX: 44,
                                          tempBorderRadiusType: "square",
                                          borderTopLeftRadius: 2,
                                          borderTopRightRadius: 2,
                                          borderBottomRightRadius: 2,
                                          borderBottomLeftRadius: 2,
                                          tempBorderRadius: 2,
                                          tempBorderTopLeftRadius: 2,
                                          tempBorderTopRightRadius: 2,
                                          tempBorderBottomRightRadius: 2,
                                          tempBorderBottomLeftRadius: 2,
                                          hoverBorderRadius: 2,
                                          hoverBorderTopLeftRadius: 2,
                                          hoverBorderTopRightRadius: 2,
                                          hoverBorderBottomRightRadius: 2,
                                          hoverBorderBottomLeftRadius: 2,
                                          tempHoverBorderRadius: 2,
                                          tempHoverBorderTopLeftRadius: 2,
                                          tempHoverBorderTopRightRadius: 2,
                                          tempHoverBorderBottomRightRadius: 2,
                                          tempHoverBorderBottomLeftRadius: 2,
                                          tempBorderWidth: 2,
                                          borderStyle: "solid",
                                          boxShadow: 0,
                                          boxShadowColorHex: "#000000",
                                          boxShadowColorOpacity: 0,
                                          boxShadowColorPalette: 0,
                                          boxShadowBlur: 0,
                                          boxShadowSpread: 0,
                                          boxShadowVertical: 0,
                                          boxShadowHorizontal: 0,
                                          tempBoxShadowColorPalette: "",
                                          tempBoxShadowColorOpacity: 1,
                                          customCSS: "",
                                          tabletPadding: 11,
                                          tempTabletPadding: 11,
                                          tabletFontStyle: "button",
                                          tabletFontWeight: 700,
                                          tabletLineHeight: 1.8,
                                          tabletLetterSpacing: 1,
                                          tempTabletBorderRadius: 2,
                                          mobilePadding: 11,
                                          tempMobilePadding: 11,
                                          mobileFontStyle: "button",
                                          mobileFontWeight: 700,
                                          mobileLineHeight: 1.8,
                                          mobileLetterSpacing: 1,
                                          tempMobileBorderRadius: 2,
                                          linkType: "anchor",
                                          linkAnchor: "essjeveederfnmzpbppolbjnotxmbqmgufjy",
                                          fontFamilyType: "google",
                                          families: {
                                            fontFamily: "montserrat",
                                          },
                                          paddingSuffix: "px",
                                          paddingTopSuffix: "px",
                                          paddingRightSuffix: "px",
                                          paddingBottomSuffix: "px",
                                          paddingLeftSuffix: "px",
                                          tempBorderStyle: "solid",
                                          borderWidthType: "grouped",
                                          borderTopWidth: 2,
                                          borderRightWidth: 2,
                                          borderBottomWidth: 2,
                                          borderLeftWidth: 2,
                                          tempBorderTopWidth: 2,
                                          tempBorderRightWidth: 2,
                                          tempBorderBottomWidth: 2,
                                          tempBorderLeftWidth: 2,
                                          tempBoxShadow: "on",
                                          tempBoxShadowBlur: 0,
                                          tempBoxShadowSpread: 0,
                                          tempBoxShadowVertical: 0,
                                          tempBoxShadowHorizontal: 0,
                                          hoverTransition: 50,
                                          tabletPaddingSuffix: "px",
                                          tabletPaddingTopSuffix: "px",
                                          tabletPaddingRightSuffix: "px",
                                          tabletPaddingBottomSuffix: "px",
                                          tabletPaddingLeftSuffix: "px",
                                          mobilePaddingSuffix: "px",
                                          mobilePaddingTopSuffix: "px",
                                          mobilePaddingRightSuffix: "px",
                                          mobilePaddingBottomSuffix: "px",
                                          mobilePaddingLeftSuffix: "px",
                                          tempMobileBoxShadowHorizontal: null,
                                        },
                                      },
                                    ],
                                    _id: "lzvdtdqjhlfejusztbsyqbtcolzmctaxmjst",
                                    horizontalAlign: "left",
                                    marginTopSuffix: "px",
                                    marginTop: 0,
                                    margin: 0,
                                    marginSuffix: "px",
                                    marginBottomSuffix: "px",
                                    marginBottom: 0,
                                    itemPadding: 50,
                                    itemPaddingRight: 50,
                                    itemPaddingLeft: 50,
                                    tabletHorizontalAlign: "center",
                                    tabletMarginBottom: -20,
                                    tabletMargin: 0,
                                    tabletMarginSuffix: "px",
                                    tabletMarginTop: 0,
                                    mobileItemPadding: 34,
                                    mobileItemPaddingRight: 34,
                                    mobileItemPaddingLeft: 34,
                                    mobileMarginBottom: -20,
                                    mobileMargin: 0,
                                    mobileMarginSuffix: "px",
                                    mobileHorizontalAlign: "left",
                                    mobileMarginType: "grouped",
                                    tabletItemPadding: 58,
                                    tabletItemPaddingRight: 58,
                                    tabletItemPaddingLeft: 58,
                                  },
                                },
                              ],
                              _id: "dogufgmksrnuhmexqknkurhyvvsmgbgavbww",
                              width: 70.4,
                              tabsState: "tabNormal",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "tabOverlay",
                              paddingLeft: 30,
                              paddingLeftSuffix: "px",
                              padding: 15,
                              paddingRight: 30,
                              paddingRightSuffix: "px",
                              tabletWidth: 62,
                              verticalAlign: "center",
                              mobileWidth: 75.5,
                              mobilePaddingLeft: 20,
                              mobilePaddingLeftSuffix: "px",
                              mobilePadding: 0,
                              mobilePaddingRight: 0,
                              mobilePaddingRightSuffix: "px",
                              paddingTop: 0,
                              paddingTopSuffix: "px",
                              paddingBottom: 0,
                              paddingBottomSuffix: "px",
                              mobileMarginBottom: 0,
                              mobileMarginBottomSuffix: "px",
                              mobileMargin: 10,
                              mobilePaddingType: "ungrouped",
                            },
                          },
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Cloneable",
                                  value: {
                                    _styles: ["wrapper-clone", "wrapper-clone--icon"],
                                    items: [
                                      {
                                        type: "Icon",
                                        value: {
                                          _styles: ["icon"],
                                          _id: "pbrsdiiqyjzdodpcdhonqinukwhfqeejfqav",
                                          size: "custom",
                                          customSize: 16,
                                          borderRadius: 0,
                                          name: "logo-facebook",
                                          type: "glyph",
                                          colorPalette: "color2",
                                          colorOpacity: 1,
                                          hoverColorHex: "#b26889",
                                          hoverColorOpacity: 1,
                                          hoverColorPalette: "color3",
                                        },
                                      },
                                      {
                                        type: "Icon",
                                        value: {
                                          _styles: ["icon"],
                                          _id: "zqmkyxdqnwxnwtzuqkttxsyinzdxfemgbbfq",
                                          size: "custom",
                                          customSize: 16,
                                          borderRadius: 0,
                                          name: "logo-instagram",
                                          type: "glyph",
                                          colorPalette: "color2",
                                          colorOpacity: 1,
                                          hoverColorHex: "#b26889",
                                          hoverColorOpacity: 1,
                                          hoverColorPalette: "color3",
                                          className: "",
                                          smallSize: 32,
                                          mediumSize: 48,
                                          largeSize: 64,
                                          padding: 0,
                                          tempPadding: 20,
                                          colorHex: "#239ddb",
                                          tempColorOpacity: 1,
                                          tempColorPalette: "color3",
                                          tempHoverColorOpacity: 1,
                                          tempHoverColorPalette: "color3",
                                          bgColorType: "solid",
                                          gradientActivePointer: "startPointer",
                                          gradientStartPointer: 0,
                                          gradientFinishPointer: 100,
                                          gradientType: "linear",
                                          gradientLinearDegree: 90,
                                          gradientRadialDegree: 90,
                                          hoverBgColorType: "solid",
                                          hoverGradientActivePointer: "startPointer",
                                          hoverGradientStartPointer: 0,
                                          hoverGradientFinishPointer: 100,
                                          hoverGradientType: "linear",
                                          hoverGradientLinearDegree: 90,
                                          hoverGradientRadialDegree: 90,
                                          bgColorHex: "#bde1f4",
                                          bgColorOpacity: 0,
                                          bgColorPalette: "",
                                          tempBgColorOpacity: 1,
                                          tempBgColorPalette: "color5",
                                          hoverBgColorHex: "#bde1f4",
                                          hoverBgColorOpacity: 0,
                                          hoverBgColorPalette: "",
                                          tempHoverBgColorOpacity: 1,
                                          tempHoverBgColorPalette: "color5",
                                          gradientColorHex: "#009900",
                                          gradientColorOpacity: 1,
                                          gradientColorPalette: "",
                                          tempGradientColorOpacity: 1,
                                          tempGradientColorPalette: "",
                                          hoverGradientColorHex: "#009900",
                                          hoverGradientColorOpacity: 0,
                                          hoverGradientColorPalette: "",
                                          tempHoverGradientColorOpacity: 1,
                                          tempHoverGradientColorPalette: "",
                                          borderColorHex: "#239ddb",
                                          borderColorOpacity: 0,
                                          borderColorPalette: "",
                                          tempBorderColorOpacity: 1,
                                          tempBorderColorPalette: "color3",
                                          hoverBorderColorHex: "#239ddb",
                                          hoverBorderColorOpacity: 0,
                                          hoverBorderColorPalette: "",
                                          tempHoverBorderColorOpacity: 1,
                                          tempHoverBorderColorPalette: "color3",
                                          "//1":
                                            "Astea 2 key de jos au fost folosite in trecut si sunt foarte importante. Trebuei atent sa vem ce afcem cu ele",
                                          borderRadiusType: "",
                                          tempBorderRadiusType: "rounded",
                                          borderTopLeftRadius: 0,
                                          borderTopRightRadius: 0,
                                          borderBottomRightRadius: 0,
                                          borderBottomLeftRadius: 0,
                                          tempBorderRadius: 4,
                                          tempBorderTopLeftRadius: 4,
                                          tempBorderTopRightRadius: 4,
                                          tempBorderBottomRightRadius: 4,
                                          tempBorderBottomLeftRadius: 4,
                                          hoverBorderRadius: 0,
                                          hoverBorderTopLeftRadius: 0,
                                          hoverBorderTopRightRadius: 0,
                                          hoverBorderBottomRightRadius: 0,
                                          hoverBorderBottomLeftRadius: 0,
                                          tempHoverBorderRadius: 4,
                                          tempHoverBorderTopLeftRadius: 4,
                                          tempHoverBorderTopRightRadius: 4,
                                          tempHoverBorderBottomRightRadius: 4,
                                          tempHoverBorderBottomLeftRadius: 4,
                                          fillType: "default",
                                          tempFillType: "filled",
                                          borderWidth: 0,
                                          tempBorderWidth: 3,
                                          borderStyle: "solid",
                                          boxShadow: "off",
                                          boxShadowColorHex: "#000000",
                                          boxShadowColorOpacity: 1,
                                          boxShadowColorPalette: "",
                                          boxShadowBlur: 4,
                                          boxShadowSpread: 0,
                                          boxShadowVertical: 2,
                                          boxShadowHorizontal: 1,
                                          tempBoxShadowColorPalette: "",
                                          tempBoxShadowColorOpacity: 1,
                                          strokeWidth: 1,
                                          customCSS: "",
                                          tempMobilePadding: 20,
                                          tempMobileBorderRadius: 4,
                                          tabletPadding: null,
                                        },
                                      },
                                    ],
                                    _id: "tlnacnukvptejbeisappprnnfaamqxtxtnxk",
                                    itemPadding: 20,
                                    itemPaddingRight: 20,
                                    itemPaddingLeft: 20,
                                    horizontalAlign: "right",
                                    marginBottomSuffix: "px",
                                    marginBottom: -14,
                                    margin: 0,
                                    marginSuffix: "px",
                                    marginTopSuffix: "px",
                                    tabletMarginTop: 0,
                                    tabletMargin: 0,
                                    tabletMarginSuffix: "px",
                                    tabletMarginBottom: -20,
                                    mobileHorizontalAlign: "right",
                                    mobileMarginBottom: 0,
                                    mobileMargin: 0,
                                    mobileMarginSuffix: "px",
                                    mobileMarginTop: 15,
                                  },
                                },
                              ],
                              _id: "uqjfwiiwubayoqklwcwropfvqbgcjujfjbdh",
                              width: 16.1,
                              tabsState: "tabNormal",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "tabOverlay",
                              tabletWidth: 15.2,
                              verticalAlign: "top",
                              tabletMarginTop: 6,
                              tabletMarginTopSuffix: "px",
                              tabletMargin: 0,
                              paddingTop: 0,
                              paddingTopSuffix: "px",
                              padding: 15,
                              paddingBottom: 0,
                              paddingBottomSuffix: "px",
                              showOnMobile: "on",
                              mobileMarginType: "ungrouped",
                              mobileWidth: 24,
                              mobileMargin: 0,
                              mobileMarginSuffix: "px",
                              mobileMarginTop: 10,
                              mobileMarginRight: 0,
                              mobileMarginBottom: 0,
                              mobileMarginLeft: 0,
                              mobilePaddingRight: 20,
                              mobilePaddingRightSuffix: "px",
                              mobilePadding: 0,
                              mobileMarginTopSuffix: "px",
                              mobilePaddingType: "ungrouped",
                            },
                          },
                        ],
                        _id: "mfdnkmuchjhxbkaaecfovcaqojrvzzrnqzuq",
                      },
                    },
                  ],
                  _id: "pngaujrmjxswjlsjpokomdaisxcnobkvzpfm",
                  paddingType: "ungrouped",
                  paddingTop: 40,
                  paddingBottom: 40,
                  padding: 75,
                  tabsState: "tabNormal",
                  tabsCurrentElement: "tabCurrentElement",
                  tabsColor: "tabOverlay",
                  tabletPaddingType: "ungrouped",
                  tabletPaddingTop: 30,
                  tabletPaddingBottom: 15,
                  tabletPadding: 50,
                  mobilePaddingType: "ungrouped",
                  mobilePaddingTop: 15,
                  mobilePaddingBottom: 15,
                  mobilePadding: 25,
                },
              },
            ],
            _id: "rordfplksjaaseazoonjyiaezqnaiavkolkf",
            _thumbnailSrc: 200357,
            _thumbnailWidth: 600,
            _thumbnailHeight: 39,
            _thumbnailTime: 1631622943544,
          },
          blockId: "Blank000Light",
        },
        {
          type: "Section",
          value: {
            _styles: ["section"],
            items: [
              {
                type: "SectionItem",
                value: {
                  _styles: ["section-item"],
                  items: [
                    {
                      type: "Row",
                      value: {
                        _styles: ["row", "hide-row-borders", "padding-0"],
                        items: [
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "qxjdjrywqqfivodndbmoxypvvfiwflpswmql",
                                          text: '<p class="brz-tp-abovetitle"><strong class="brz-cp-color4">HELLO &amp; WELCOME!</strong></p>',
                                        },
                                      },
                                    ],
                                    _id: "vlmgxhsgvtmdfvoxvmedgawumwwrpzmsmiux",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "qgiczgppvtqjxbzackfzfeyfbducqacfxaem",
                                          text: '<h1 class="brz-tp-heading1"><span class="brz-cp-color2">We are a </span><strong class="brz-cp-color3">Copywriting Agency</strong><span class="brz-cp-color2"> with passion</span></h1>',
                                        },
                                      },
                                    ],
                                    _id: "hscjxcosumqgcnwusgezblrivlnnezkwgste",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "dplzuopiaashybxzftbxthsdneuffeyviavh",
                                          text: '<p class="brz-tp-subtitle brz-mt-lg-10 brz-mb-lg-10 brz-mt-sm-0 brz-mb-sm-0"><span class="brz-cp-color7">I would occasionally fall, from the same with him who endeavors the deck. Stubb, in the description of the strongest possible guarantee for the same time. So down there, some ten feet below the whale\'s back, the harpooneer the.</span></p>',
                                        },
                                      },
                                    ],
                                    _id: "atnvlegmhtkodlwtwwofmurhfmbbvixasqse",
                                    tabletPaddingType: "ungrouped",
                                    paddingRightSuffix: "px",
                                    tabletPaddingRight: 20,
                                    tabletPadding: 0,
                                    tabletPaddingSuffix: "px",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--spacer"],
                                    items: [
                                      {
                                        type: "Spacer",
                                        value: {
                                          _styles: ["spacer"],
                                          _id: "ijdjvuhgeaoicheatzzetoeogrzbwxncxxdq",
                                          height: 50,
                                          tabletHeight: 10,
                                          mobileHeight: 5,
                                        },
                                      },
                                    ],
                                    _id: "pnewhosfyzspldrqzirifuybnahpluhxujsw",
                                    showOnTablet: "on",
                                    showOnMobile: "off",
                                  },
                                },
                                {
                                  type: "Cloneable",
                                  value: {
                                    _styles: ["wrapper-clone", "wrapper-clone--button"],
                                    items: [
                                      {
                                        type: "Button",
                                        value: {
                                          _styles: ["button"],
                                          _id: "tlvdsarqgyreblpwqwgjpfilhrogfqlxxhal",
                                          text: "View Our Services",
                                          iconName: "tail-down",
                                          iconType: "outline",
                                          iconPosition: "left",
                                          colorPalette: "color2",
                                          colorOpacity: 1,
                                          fillType: "default",
                                          tempFillType: "filled",
                                          paddingRL: 0,
                                          paddingRight: 0,
                                          paddingLeft: 0,
                                          paddingTB: 14,
                                          paddingTop: 14,
                                          paddingBottom: 14,
                                          borderRadiusType: "",
                                          borderRadius: 2,
                                          borderWidth: 0,
                                          borderColorOpacity: 0,
                                          borderColorPalette: "",
                                          bgColorOpacity: 0,
                                          bgColorPalette: "color2",
                                          hoverBgColorOpacity: 0,
                                          hoverBorderColorOpacity: 0,
                                          hoverBgColorHex: "#b26889",
                                          tempHoverBgColorOpacity: 0.8,
                                          hoverBgColorPalette: "color3",
                                          tempHoverBgColorPalette: "color3",
                                          hoverBorderColorHex: "#3a566e",
                                          hoverBorderColorPalette: "color3",
                                          tempHoverBorderColorPalette: "color3",
                                          hoverColorPalette: "color3",
                                          hoverColorOpacity: 1,
                                          tempBgColorPalette: "color2",
                                          tempBorderColorPalette: "",
                                          bgColorHex: "#3a566e",
                                          tempBgColorOpacity: 1,
                                          borderColorHex: "#239ddb",
                                          iconSize: "medium",
                                          iconCustomSize: 24,
                                          tabletSize: "small",
                                          tabletFontSize: 11,
                                          tabletPaddingTB: 11,
                                          tabletPaddingTop: 11,
                                          tabletPaddingBottom: 11,
                                          tempTabletPaddingTB: 11,
                                          tempTabletPaddingTop: 11,
                                          tempTabletPaddingBottom: 11,
                                          tabletPaddingRL: 0,
                                          tabletPaddingRight: 0,
                                          tabletPaddingLeft: 0,
                                          tempTabletPaddingRL: 26,
                                          tempTabletPaddingRight: 26,
                                          tempTabletPaddingLeft: 26,
                                          tabletBorderRadius: 2,
                                          mobileSize: "small",
                                          mobileFontSize: 11,
                                          mobilePaddingTB: 11,
                                          mobilePaddingTop: 11,
                                          mobilePaddingBottom: 11,
                                          tempMobilePaddingTB: 11,
                                          tempMobilePaddingTop: 11,
                                          tempMobilePaddingBottom: 11,
                                          mobilePaddingRL: 0,
                                          mobilePaddingRight: 0,
                                          mobilePaddingLeft: 0,
                                          tempMobilePaddingRL: 26,
                                          tempMobilePaddingRight: 26,
                                          tempMobilePaddingLeft: 26,
                                          mobileBorderRadius: 2,
                                          linkType: "anchor",
                                          linkAnchor: "pacwvjuxmpbjcozcfwpjffuerrbvmaeiyrry",
                                        },
                                      },
                                    ],
                                    _id: "gsdelkabzwqlvxcfbyugjlkvukhcdizwwvbp",
                                    horizontalAlign: "left",
                                    marginLeftSuffix: "px",
                                    marginLeft: -10,
                                    margin: 0,
                                    marginSuffix: "px",
                                  },
                                },
                              ],
                              _id: "iwkibqwhdxlphaykxdaugtvhgoipccfcvewt",
                              tabletWidth: 58.5,
                              mobilePaddingRight: 10,
                              mobilePaddingRightSuffix: "px",
                              mobilePadding: 0,
                              tabsState: "tabNormal",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "tabOverlay",
                              mobilePaddingLeft: 20,
                              mobilePaddingLeftSuffix: "px",
                              tabletPaddingLeft: 20,
                              tabletPaddingLeftSuffix: "px",
                              tabletPadding: 15,
                              mobilePaddingType: "ungrouped",
                            },
                          },
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--spacer"],
                                    items: [
                                      {
                                        type: "Spacer",
                                        value: {
                                          _styles: ["spacer"],
                                          _id: "ztgjtuzlzbhflfzvuqdwyrupidlnfsttkhoo",
                                          mobileHeight: 10,
                                        },
                                      },
                                    ],
                                    _id: "tbtsjhlfcskhpyksrvcbyjwrlnjmpqchrcib",
                                  },
                                },
                              ],
                              _id: "izeyrzijoibvqqtnmyfhmlaxdtrtttqvknjx",
                              tabletWidth: 40.8,
                              showOnMobile: "off",
                              tabsState: "tabNormal",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "tabOverlay",
                            },
                          },
                        ],
                        _id: "fpzfquyolhpfkzdrzdiamefjwrzkffqfdzpu",
                      },
                    },
                    {
                      type: "Wrapper",
                      value: {
                        _styles: ["wrapper", "wrapper--spacer"],
                        items: [
                          {
                            type: "Spacer",
                            value: {
                              _styles: ["spacer"],
                              _id: "qhbqkduswaoxmgfwrnsecbgpvkspdjobdfpq",
                              height: 80,
                              tabletHeight: 23,
                              mobileHeight: 10,
                            },
                          },
                        ],
                        _id: "abamexvjqlmytwxnbxrembmosozxuhyiixbq",
                        showOnTablet: "on",
                        showOnMobile: "off",
                      },
                    },
                    {
                      type: "Row",
                      value: {
                        _styles: ["row", "hide-row-borders", "padding-0"],
                        items: [
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "ohfejfbqwdbqoowxgjxovsxxnjjlwzzsqwxj",
                                          text: '<p class="brz-tp-abovetitle"><strong class="brz-cp-color3">SERVICES</strong></p>',
                                        },
                                      },
                                    ],
                                    _id: "wojvnioozykgfpyjksufqhmyusjlqwvnxzpw",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "rmzzztljhgguatyznyipimomvfnwbtvewlnw",
                                          text: '<h1 class="brz-tp-heading1 brz-mt-xs-5 brz-mb-xs-5"><span class="brz-cp-color2">What we do</span></h1>',
                                        },
                                      },
                                    ],
                                    _id: "lysaykkgqwsqmxnjnlnhhaqvurcnyqpsrogt",
                                    marginType: "grouped",
                                    tabletMarginType: "grouped",
                                    mobileMarginType: "grouped",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "cgquzpsxzaxbnedbpflbchwoxlqtwptikbsh",
                                          text: '<p class="brz-tp-paragraph"><span class="brz-cp-color7">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</span></p>',
                                        },
                                      },
                                    ],
                                    _id: "tdaoqtrxhtwgydlzyffovisbuoacscthckqa",
                                    paddingType: "ungrouped",
                                    paddingRightSuffix: "px",
                                    paddingRight: 0,
                                    padding: 0,
                                    paddingSuffix: "px",
                                  },
                                },
                              ],
                              _id: "hvgxktkbebjgubpvjcymazzbyuvucalzugwx",
                              width: 59.8,
                              tabletWidth: 64.4,
                              className: "",
                              borderStyle: "solid",
                              tempBorderStyle: "solid",
                              borderWidthType: "grouped",
                              borderWidth: 0,
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              tempBorderWidth: 4,
                              tempBorderTopWidth: 4,
                              tempBorderRightWidth: 4,
                              tempBorderBottomWidth: 4,
                              tempBorderLeftWidth: 4,
                              borderRadiusType: "grouped",
                              borderRadius: 0,
                              borderTopLeftRadius: 0,
                              borderTopRightRadius: 0,
                              borderBottomRightRadius: 0,
                              borderBottomLeftRadius: 0,
                              tempBorderRadius: 0,
                              tempBorderTopLeftRadius: 0,
                              tempBorderTopRightRadius: 0,
                              tempBorderBottomRightRadius: 0,
                              tempBorderBottomLeftRadius: 0,
                              bgColorType: "solid",
                              gradientActivePointer: "startPointer",
                              gradientStartPointer: 0,
                              gradientFinishPointer: 100,
                              gradientType: "linear",
                              gradientLinearDegree: 90,
                              gradientRadialDegree: 90,
                              bgColorHex: "#000000",
                              bgColorOpacity: 0,
                              bgColorPalette: "",
                              tempBgColorOpacity: 1,
                              tempBgColorPalette: "",
                              gradientColorHex: "#009900",
                              gradientColorOpacity: 1,
                              gradientColorPalette: "",
                              tempGradientColorOpacity: 1,
                              tempGradientColorPalette: "",
                              borderColorHex: "#66738d",
                              borderColorOpacity: 0,
                              borderColorPalette: "",
                              tempBorderColorOpacity: 1,
                              tempBorderColorPalette: "",
                              hoverTransition: 50,
                              verticalAlign: "top",
                              paddingType: "ungrouped",
                              padding: 15,
                              paddingTop: 5,
                              paddingRight: 15,
                              paddingBottom: 5,
                              paddingLeft: 15,
                              paddingSuffix: "px",
                              paddingTopSuffix: "px",
                              paddingRightSuffix: "px",
                              paddingBottomSuffix: "px",
                              paddingLeftSuffix: "px",
                              marginType: "grouped",
                              margin: 0,
                              marginTop: 0,
                              marginRight: 0,
                              marginBottom: 0,
                              marginLeft: 0,
                              marginSuffix: "px",
                              marginTopSuffix: "px",
                              marginRightSuffix: "px",
                              marginBottomSuffix: "px",
                              marginLeftSuffix: "px",
                              boxShadow: "",
                              boxShadowColorHex: "#000000",
                              boxShadowColorOpacity: 0,
                              boxShadowColorPalette: 0,
                              boxShadowBlur: 0,
                              boxShadowSpread: 0,
                              boxShadowVertical: 0,
                              boxShadowHorizontal: 0,
                              tempBoxShadowColorPalette: "",
                              tempBoxShadowColorOpacity: 1,
                              customClassName: "",
                              customCSS: "",
                              tabletPaddingType: "ungrouped",
                              tabletPadding: 15,
                              tabletPaddingTop: 5,
                              tabletPaddingRight: 15,
                              tabletPaddingBottom: 5,
                              tabletPaddingLeft: 20,
                              tabletPaddingSuffix: "px",
                              tabletPaddingTopSuffix: "px",
                              tabletPaddingRightSuffix: "px",
                              tabletPaddingBottomSuffix: "px",
                              tabletPaddingLeftSuffix: "px",
                              tempTabletPadding: 10,
                              tempTabletPaddingTop: 10,
                              tempTabletPaddingRight: 10,
                              tempTabletPaddingBottom: 10,
                              tempTabletPaddingLeft: 10,
                              tabletMarginType: "ungrouped",
                              tabletMargin: 0,
                              tabletMarginTop: 0,
                              tabletMarginRight: 0,
                              tabletMarginBottom: 0,
                              tabletMarginLeft: 0,
                              tabletMarginSuffix: "px",
                              tabletMarginTopSuffix: "px",
                              tabletMarginRightSuffix: "px",
                              tabletMarginBottomSuffix: "px",
                              tabletMarginLeftSuffix: "px",
                              mobilePaddingType: "ungrouped",
                              mobilePadding: 0,
                              mobilePaddingTop: 0,
                              mobilePaddingRight: 30,
                              mobilePaddingBottom: 0,
                              mobilePaddingLeft: 20,
                              mobilePaddingSuffix: "px",
                              mobilePaddingTopSuffix: "px",
                              mobilePaddingRightSuffix: "px",
                              mobilePaddingBottomSuffix: "px",
                              mobilePaddingLeftSuffix: "px",
                              tempMobilePadding: 10,
                              tempMobilePaddingTop: 10,
                              tempMobilePaddingRight: 10,
                              tempMobilePaddingBottom: 10,
                              tempMobilePaddingLeft: 10,
                              mobileMarginType: "ungrouped",
                              mobileMargin: 10,
                              mobileMarginTop: 10,
                              mobileMarginRight: 0,
                              mobileMarginBottom: 10,
                              mobileMarginLeft: 0,
                              mobileMarginSuffix: "px",
                              mobileMarginTopSuffix: "px",
                              mobileMarginRightSuffix: "px",
                              mobileMarginBottomSuffix: "px",
                              mobileMarginLeftSuffix: "px",
                              tabsState: "",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "",
                              tempBoxShadow: "on",
                            },
                          },
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--spacer"],
                                    items: [
                                      {
                                        type: "Spacer",
                                        value: {
                                          _styles: ["spacer"],
                                          _id: "uurzmqyqyrrnrqijxowmhbjockcmobnnygtm",
                                          tabletHeight: 10,
                                          mobileHeight: 10,
                                        },
                                      },
                                    ],
                                    _id: "akgzoweimoqcsmnxrqwckaoiicmwyhkaftrl",
                                  },
                                },
                              ],
                              _id: "dvmsedzzpolrxtneniklpcnqkcwlimmtynyr",
                              width: 40.2,
                              showOnTablet: "on",
                              tabsState: "tabNormal",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "tabOverlay",
                              tabletWidth: 30.6,
                              showOnMobile: "off",
                            },
                          },
                        ],
                        _id: "vglrdxxfliluwrwautgvejpvxlmmxfbnivdr",
                      },
                    },
                  ],
                  _id: "uapljriyarsgmyvuruxqpyotzkkbzecwkovt",
                  tabsCurrentElement: "tabCurrentElement",
                  tabsState: "tabNormal",
                  tabsColor: "tabOverlay",
                  bgImageWidth: 1920,
                  bgImageHeight: 1031,
                  bgImageSrc: "e43c6529e515c87c630557e1d9a58349.jpg",
                  bgColorOpacity: 0,
                  tempBgColorOpacity: 1,
                  borderRadius: 0,
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  tempBorderTopLeftRadius: 0,
                  tempBorderTopRightRadius: 0,
                  tempBorderBottomLeftRadius: 0,
                  tempBorderBottomRightRadius: 0,
                  bgPositionX: 80,
                  bgPositionY: 50,
                  paddingType: "ungrouped",
                  paddingTop: 53,
                  paddingBottom: 15,
                  padding: 75,
                  tabletBgPositionX: 66,
                  tabletBgPositionY: 33,
                  tabletBorderRadius: 0,
                  tabletBorderTopLeftRadius: 0,
                  tabletBorderTopRightRadius: 0,
                  tabletBorderBottomLeftRadius: 0,
                  tabletBorderBottomRightRadius: 0,
                  tempTabletBorderTopLeftRadius: 0,
                  tempTabletBorderTopRightRadius: 0,
                  tempTabletBorderBottomLeftRadius: 0,
                  tempTabletBorderBottomRightRadius: 0,
                  tabletPaddingType: "ungrouped",
                  tabletPaddingTop: 50,
                  tabletPaddingBottom: 50,
                  tabletPadding: 50,
                  mobileBgPositionX: 59,
                  mobileBgPositionY: 77,
                  mobileBorderRadius: 0,
                  mobileBorderTopLeftRadius: 0,
                  mobileBorderTopRightRadius: 0,
                  mobileBorderBottomLeftRadius: 0,
                  mobileBorderBottomRightRadius: 0,
                  tempMobileBorderTopLeftRadius: 0,
                  tempMobileBorderTopRightRadius: 0,
                  tempMobileBorderBottomLeftRadius: 0,
                  tempMobileBorderBottomRightRadius: 0,
                  mobilePaddingType: "ungrouped",
                  mobilePaddingTop: 16,
                  mobilePaddingBottom: 15,
                  mobilePadding: 25,
                  mobileBgImageWidth: 0,
                  mobileBgImageHeight: 0,
                  mobileBgImageSrc: "",
                  mobileBgColorOpacity: 0,
                  tempMobileBgColorOpacity: 1,
                },
              },
            ],
            _id: "qteyezanqjmwhnmofebgfxcaepuowromaztm",
            _thumbnailSrc: 200373,
            _thumbnailWidth: 600,
            _thumbnailHeight: 269,
            _thumbnailTime: 1631622946943,
            anchorName: "about",
          },
          blockId: "Blank000Light",
        },
        {
          type: "Section",
          value: {
            _styles: ["section"],
            items: [
              {
                type: "SectionItem",
                value: {
                  _styles: ["section-item"],
                  items: [
                    {
                      type: "Row",
                      value: {
                        _styles: ["row", "hide-row-borders", "padding-0"],
                        items: [
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--image"],
                                    items: [
                                      {
                                        type: "Image",
                                        value: {
                                          _styles: ["image"],
                                          _id: "ffpvqhcjtolmysjwiyzdmstlvcukymqqlmkx",
                                          imageWidth: 1200,
                                          imageHeight: 700,
                                          imageSrc: "2eb8c6a8ffdab6a9008a3cfae205c1ad.jpg",
                                          height: 100,
                                          positionX: 50,
                                          positionY: 50,
                                          imagePopulation: "",
                                          resize: 95,
                                          borderRadiusType: "custom",
                                          borderRadius: 10,
                                          tempBorderRadius: 10,
                                          tabsState: "tabNormal",
                                          boxShadow: "on",
                                          boxShadowBlur: 20,
                                          tempBoxShadowBlur: 20,
                                          boxShadowSpread: -15,
                                          tempBoxShadowSpread: -15,
                                          boxShadowVertical: 31,
                                          tempBoxShadowVertical: 31,
                                          boxShadowHorizontal: 0,
                                          tempBoxShadowHorizontal: 0,
                                          boxShadowColorHex: "#000000",
                                          boxShadowColorOpacity: 0.32,
                                          tempBoxShadowColorOpacity: 0.32,
                                          boxShadowColorPalette: "",
                                          tempBoxShadowColorPalette: "",
                                          tabletResize: 100,
                                          mobileResize: 92,
                                        },
                                      },
                                    ],
                                    _id: "dybseeepyaifgztpawffgxrqvbxsmbonhqwk",
                                    horizontalAlign: "right",
                                    tabletHorizontalAlign: "left",
                                    marginTopSuffix: "px",
                                    tabletMarginTop: 20,
                                    tabletMargin: 20,
                                    tabletMarginSuffix: "px",
                                    marginLeftSuffix: "px",
                                    tabletMarginLeft: 20,
                                    marginBottomSuffix: "px",
                                    tabletMarginBottom: 20,
                                    tabletMarginType: "grouped",
                                    tabletMarginTopSuffix: "px",
                                    tabletMarginRightSuffix: "px",
                                    tabletMarginBottomSuffix: "px",
                                    tabletMarginLeftSuffix: "px",
                                    tabletMarginRight: 20,
                                    mobileMarginTop: 110,
                                    mobileMargin: 0,
                                    mobileMarginSuffix: "px",
                                    mobileMarginBottom: 110,
                                  },
                                },
                              ],
                              _id: "jonbrqnntmaacfpsdvyxaysorprzwijurswc",
                              width: 55.7,
                              tabletWidth: 49.4,
                              tabsCurrentElement: "tabCurrentElement",
                              bgImageWidth: 1250,
                              bgImageHeight: 1322,
                              bgImageSrc: "973bfde7e357b4a4b5a45cacc5a7cc94.png",
                              bgColorOpacity: 0,
                              tempBgColorOpacity: 1,
                              borderRadius: 0,
                              borderTopLeftRadius: 0,
                              borderTopRightRadius: 0,
                              borderBottomLeftRadius: 0,
                              borderBottomRightRadius: 0,
                              tempBorderTopLeftRadius: 0,
                              tempBorderTopRightRadius: 0,
                              tempBorderBottomLeftRadius: 0,
                              tempBorderBottomRightRadius: 0,
                              tabletPaddingRight: 0,
                              tabletPaddingLeft: 0,
                              mobilePaddingRight: 10,
                              mobilePaddingLeft: 10,
                              tabsState: "tabNormal",
                              tabsColor: "tabOverlay",
                              verticalAlign: "center",
                              margin: 10,
                              marginSuffix: "px",
                              marginTop: 10,
                              marginRight: 10,
                              marginBottom: 10,
                              marginLeft: 10,
                              paddingRight: 0,
                              paddingRightSuffix: "px",
                              padding: 15,
                              tabletBgImageWidth: 0,
                              tabletBgImageHeight: 0,
                              tabletBgImageSrc: "",
                              tabletBgColorOpacity: 0,
                              tempTabletBgColorOpacity: 1,
                              tabletBorderRadius: 0,
                              tabletBorderTopLeftRadius: 0,
                              tabletBorderTopRightRadius: 0,
                              tabletBorderBottomLeftRadius: 0,
                              tabletBorderBottomRightRadius: 0,
                              tempTabletBorderTopLeftRadius: 0,
                              tempTabletBorderTopRightRadius: 0,
                              tempTabletBorderBottomLeftRadius: 0,
                              tempTabletBorderBottomRightRadius: 0,
                              mobileWidth: 100,
                              mobilePaddingType: "ungrouped",
                            },
                          },
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Cloneable",
                                  value: {
                                    _styles: ["wrapper-clone", "wrapper-clone--icon"],
                                    items: [
                                      {
                                        type: "Icon",
                                        value: {
                                          _styles: ["icon"],
                                          _id: "ykaiawvlozkoflioemqyuancwxyyuwgdscue",
                                          size: "custom",
                                          customSize: 26,
                                          borderRadius: 31,
                                          borderRadiusType: "custom",
                                          tempBorderRadiusType: "custom",
                                          fillType: "filled",
                                          borderWidth: 0,
                                          borderColorOpacity: 0,
                                          borderColorPalette: 0,
                                          bgColorOpacity: 0.22,
                                          bgColorPalette: "color3",
                                          padding: 15,
                                          hoverBgColorOpacity: 0.22,
                                          hoverBorderColorOpacity: 1,
                                          tempBorderWidth: 3,
                                          tempPadding: 15,
                                          tempBgColorPalette: "color3",
                                          borderTopLeftRadius: 4,
                                          borderTopRightRadius: 4,
                                          borderBottomLeftRadius: 4,
                                          borderBottomRightRadius: 4,
                                          tempBorderTopLeftRadius: 4,
                                          tempBorderTopRightRadius: 4,
                                          tempBorderBottomLeftRadius: 4,
                                          tempBorderBottomRightRadius: 4,
                                          bgColorHex: "#b26889",
                                          tempBgColorOpacity: 0.22,
                                          hoverBgColorPalette: "color3",
                                          tempHoverBgColorPalette: "color3",
                                          hoverBorderRadius: 4,
                                          hoverBorderTopLeftRadius: 4,
                                          hoverBorderTopRightRadius: 4,
                                          hoverBorderBottomLeftRadius: 4,
                                          hoverBorderBottomRightRadius: 4,
                                          tempHoverBorderTopLeftRadius: 4,
                                          tempHoverBorderTopRightRadius: 4,
                                          tempHoverBorderBottomLeftRadius: 4,
                                          tempHoverBorderBottomRightRadius: 4,
                                          hoverBgColorHex: "#b26889",
                                          tempHoverBgColorOpacity: 0.22,
                                          tempFillType: "filled",
                                          hoverBorderColorPalette: "color3",
                                          hoverColorHex: "#b26889",
                                          hoverColorOpacity: 1,
                                          hoverColorPalette: "color3",
                                          tempBorderRadius: 31,
                                        },
                                      },
                                    ],
                                    _id: "adliiwfusjfyuivoijwvgmfopmzpzvquknbs",
                                    horizontalAlign: "left",
                                    marginBottomSuffix: "px",
                                    marginBottom: 0,
                                    margin: 0,
                                    marginSuffix: "px",
                                    mobileMarginBottom: 0,
                                    mobileMargin: 0,
                                    mobileMarginSuffix: "px",
                                    tabletMarginBottom: 0,
                                    tabletMargin: 0,
                                    tabletMarginSuffix: "px",
                                    marginTopSuffix: "px",
                                    tabletMarginTop: 20,
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "yhoqtpezewrdylmgeftnlmcnzpabtxmejrnc",
                                          text: '<h2 class="brz-tp-heading2 brz-mt-xs-10"><span class="brz-cp-color2">Brand Identity</span></h2>',
                                        },
                                      },
                                    ],
                                    _id: "yccncysccxfiugeismivnvcjwxewxxahfqhg",
                                    marginTopSuffix: "px",
                                    marginTop: 0,
                                    margin: 0,
                                    marginSuffix: "px",
                                    tabletMarginType: "grouped",
                                    mobileMarginType: "grouped",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "cdiabihdqljjulkysjmmbobsgsvempsldqnu",
                                          text: '<p class="brz-tp-paragraph"><span class="brz-cp-color7">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad.</span></p>',
                                        },
                                      },
                                    ],
                                    _id: "kbmdtnobdpsoefywgnkrxhuzxnclehnvtkql",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--spacer"],
                                    items: [
                                      {
                                        type: "Spacer",
                                        value: {
                                          _styles: ["spacer"],
                                          _id: "vrtzkpooooumzowifvwriwqssiynkheldihp",
                                          height: 87,
                                          tabletHeight: 10,
                                          mobileHeight: 42,
                                        },
                                      },
                                    ],
                                    _id: "vvhouvbmrgdjstzfttdxytycqcalmrrepefb",
                                    showOnTablet: "on",
                                    showOnMobile: "on",
                                  },
                                },
                                {
                                  type: "Cloneable",
                                  value: {
                                    _styles: ["wrapper-clone", "wrapper-clone--icon"],
                                    items: [
                                      {
                                        type: "Icon",
                                        value: {
                                          _styles: ["icon"],
                                          _id: "aqtllhrsohnrriarkjjlnzqeyvhkofyvadft",
                                          size: "custom",
                                          customSize: 26,
                                          borderRadius: 31,
                                          borderRadiusType: "custom",
                                          tempBorderRadiusType: "custom",
                                          fillType: "filled",
                                          borderWidth: 0,
                                          borderColorOpacity: 0,
                                          borderColorPalette: 0,
                                          bgColorOpacity: 0.22,
                                          bgColorPalette: "color5",
                                          padding: 15,
                                          hoverBgColorOpacity: 0.22,
                                          hoverBorderColorOpacity: 1,
                                          tempBorderWidth: 3,
                                          tempPadding: 15,
                                          tempBgColorPalette: "color5",
                                          borderTopLeftRadius: 4,
                                          borderTopRightRadius: 4,
                                          borderBottomLeftRadius: 4,
                                          borderBottomRightRadius: 4,
                                          tempBorderTopLeftRadius: 4,
                                          tempBorderTopRightRadius: 4,
                                          tempBorderBottomLeftRadius: 4,
                                          tempBorderBottomRightRadius: 4,
                                          bgColorHex: "#b26889",
                                          tempBgColorOpacity: 0.22,
                                          hoverBgColorPalette: "color5",
                                          tempHoverBgColorPalette: "color5",
                                          hoverBorderRadius: 4,
                                          hoverBorderTopLeftRadius: 4,
                                          hoverBorderTopRightRadius: 4,
                                          hoverBorderBottomLeftRadius: 4,
                                          hoverBorderBottomRightRadius: 4,
                                          tempHoverBorderTopLeftRadius: 4,
                                          tempHoverBorderTopRightRadius: 4,
                                          tempHoverBorderBottomLeftRadius: 4,
                                          tempHoverBorderBottomRightRadius: 4,
                                          hoverBgColorHex: "#b26889",
                                          tempHoverBgColorOpacity: 0.22,
                                          tempFillType: "filled",
                                          hoverBorderColorPalette: "color3",
                                          hoverColorHex: "#b26889",
                                          hoverColorOpacity: 1,
                                          hoverColorPalette: "color5",
                                          tempBorderRadius: 31,
                                          name: "shape-polygon-2",
                                          type: "glyph",
                                          colorPalette: "color5",
                                          colorOpacity: 1,
                                        },
                                      },
                                    ],
                                    _id: "lxvymrknluttcnbcitjkwkhtiqfkdeiogzda",
                                    horizontalAlign: "left",
                                    marginBottomSuffix: "px",
                                    marginBottom: 0,
                                    margin: 0,
                                    marginSuffix: "px",
                                    mobileMarginBottom: 0,
                                    mobileMargin: 0,
                                    mobileMarginSuffix: "px",
                                    tabletMarginBottom: 0,
                                    tabletMargin: 0,
                                    tabletMarginSuffix: "px",
                                    marginTopSuffix: "px",
                                    tabletMarginTop: 20,
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "dgtfudfjuwicvoalzrkdcbihcrwgwizkcwrh",
                                          text: '<h2 class="brz-tp-heading2 brz-mt-xs-10"><span class="brz-cp-color2">Copywriting &amp; Ads</span></h2>',
                                          customCSS: "",
                                        },
                                      },
                                    ],
                                    _id: "igdpoldqwamwxfbbqhrudsxwbwtygynnkvqa",
                                    marginTopSuffix: "px",
                                    marginTop: 0,
                                    margin: 0,
                                    marginSuffix: "px",
                                    tabletMarginType: "grouped",
                                    className: "",
                                    horizontalAlign: "center",
                                    paddingType: "grouped",
                                    padding: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    paddingSuffix: "px",
                                    paddingTopSuffix: "px",
                                    paddingRightSuffix: "px",
                                    paddingBottomSuffix: "px",
                                    paddingLeftSuffix: "px",
                                    marginType: "ungrouped",
                                    marginRight: 0,
                                    marginBottom: 10,
                                    marginLeft: 0,
                                    marginRightSuffix: "px",
                                    marginBottomSuffix: "px",
                                    marginLeftSuffix: "px",
                                    customClassName: "",
                                    tabletPaddingType: "grouped",
                                    tabletPadding: 0,
                                    tabletPaddingTop: 0,
                                    tabletPaddingRight: 0,
                                    tabletPaddingBottom: 0,
                                    tabletPaddingLeft: 0,
                                    tabletPaddingSuffix: "px",
                                    tabletPaddingTopSuffix: "px",
                                    tabletPaddingRightSuffix: "px",
                                    tabletPaddingBottomSuffix: "px",
                                    tabletPaddingLeftSuffix: "px",
                                    tabletMargin: 0,
                                    tabletMarginTop: 10,
                                    tabletMarginRight: 0,
                                    tabletMarginBottom: 10,
                                    tabletMarginLeft: 0,
                                    tabletMarginSuffix: "px",
                                    tabletMarginTopSuffix: "px",
                                    tabletMarginRightSuffix: "px",
                                    tabletMarginBottomSuffix: "px",
                                    tabletMarginLeftSuffix: "px",
                                    mobilePaddingType: "grouped",
                                    mobilePadding: 0,
                                    mobilePaddingTop: 0,
                                    mobilePaddingRight: 0,
                                    mobilePaddingBottom: 0,
                                    mobilePaddingLeft: 0,
                                    mobilePaddingSuffix: "px",
                                    mobilePaddingTopSuffix: "px",
                                    mobilePaddingRightSuffix: "px",
                                    mobilePaddingBottomSuffix: "px",
                                    mobilePaddingLeftSuffix: "px",
                                    mobileMarginType: "grouped",
                                    mobileMargin: 0,
                                    mobileMarginTop: 10,
                                    mobileMarginRight: 0,
                                    mobileMarginBottom: 10,
                                    mobileMarginLeft: 0,
                                    mobileMarginSuffix: "px",
                                    mobileMarginTopSuffix: "px",
                                    mobileMarginRightSuffix: "px",
                                    mobileMarginBottomSuffix: "px",
                                    mobileMarginLeftSuffix: "px",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "xeilemmkyamjpvbpdbnfkeykiokjhypmfqse",
                                          text: '<p class="brz-tp-paragraph"><span class="brz-cp-color7">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad.</span></p>',
                                        },
                                      },
                                    ],
                                    _id: "qquvosqunxlhcncxnqtiobfyjmrhnedztvju",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--spacer"],
                                    items: [
                                      {
                                        type: "Spacer",
                                        value: {
                                          _styles: ["spacer"],
                                          _id: "rcmgjkbgtvkzwucznkoqyhukxyzmdhmidheh",
                                          height: 72,
                                          tabletHeight: 10,
                                          mobileHeight: 30,
                                        },
                                      },
                                    ],
                                    _id: "pzxjmtzeiksbnpzeumegbkjvjsuqcwbmbalv",
                                    showOnTablet: "off",
                                  },
                                },
                                {
                                  type: "Cloneable",
                                  value: {
                                    _styles: ["wrapper-clone", "wrapper-clone--button"],
                                    items: [
                                      {
                                        type: "Button",
                                        value: {
                                          _styles: ["button"],
                                          _id: "bkczschrhgogsofzrawcofhcarfnzrcevvps",
                                          text: "Client Testimonials",
                                          iconName: "tail-down",
                                          iconType: "outline",
                                          iconPosition: "left",
                                          colorPalette: "color2",
                                          colorOpacity: 1,
                                          fillType: "default",
                                          tempFillType: "filled",
                                          paddingRL: 0,
                                          paddingRight: 0,
                                          paddingLeft: 0,
                                          paddingTB: 14,
                                          paddingTop: 14,
                                          paddingBottom: 14,
                                          borderRadiusType: "",
                                          borderRadius: 2,
                                          borderWidth: 0,
                                          borderColorOpacity: 0,
                                          borderColorPalette: "",
                                          bgColorOpacity: 0,
                                          bgColorPalette: "color2",
                                          hoverBgColorOpacity: 0,
                                          hoverBorderColorOpacity: 0,
                                          hoverBgColorHex: "#b26889",
                                          tempHoverBgColorOpacity: 0.8,
                                          hoverBgColorPalette: "color3",
                                          tempHoverBgColorPalette: "color3",
                                          hoverBorderColorHex: "#3a566e",
                                          hoverBorderColorPalette: "color3",
                                          tempHoverBorderColorPalette: "color3",
                                          hoverColorPalette: "color3",
                                          hoverColorOpacity: 1,
                                          tempBgColorPalette: "color2",
                                          tempBorderColorPalette: "",
                                          bgColorHex: "#3a566e",
                                          tempBgColorOpacity: 1,
                                          borderColorHex: "#239ddb",
                                          iconSize: "medium",
                                          iconCustomSize: 24,
                                          tabletSize: "small",
                                          tabletFontSize: 11,
                                          tabletPaddingTB: 11,
                                          tabletPaddingTop: 11,
                                          tabletPaddingBottom: 11,
                                          tempTabletPaddingTB: 11,
                                          tempTabletPaddingTop: 11,
                                          tempTabletPaddingBottom: 11,
                                          tabletPaddingRL: 0,
                                          tabletPaddingRight: 0,
                                          tabletPaddingLeft: 0,
                                          tempTabletPaddingRL: 26,
                                          tempTabletPaddingRight: 26,
                                          tempTabletPaddingLeft: 26,
                                          tabletBorderRadius: 2,
                                          mobileSize: "small",
                                          mobileFontSize: 11,
                                          mobilePaddingTB: 11,
                                          mobilePaddingTop: 11,
                                          mobilePaddingBottom: 11,
                                          tempMobilePaddingTB: 11,
                                          tempMobilePaddingTop: 11,
                                          tempMobilePaddingBottom: 11,
                                          mobilePaddingRL: 0,
                                          mobilePaddingRight: 0,
                                          mobilePaddingLeft: 0,
                                          tempMobilePaddingRL: 26,
                                          tempMobilePaddingRight: 26,
                                          tempMobilePaddingLeft: 26,
                                          mobileBorderRadius: 2,
                                          linkType: "anchor",
                                          linkAnchor: "gmxdljgmwozvyzwftkjxbindnkvrnygorjud",
                                        },
                                      },
                                    ],
                                    _id: "kejxqufyrlmofradzlphfblfdpltmfvtvlkh",
                                    horizontalAlign: "left",
                                    marginBottomSuffix: "px",
                                    mobileMarginBottom: -10,
                                    mobileMargin: 0,
                                    mobileMarginSuffix: "px",
                                  },
                                },
                              ],
                              _id: "fcetkufuxqmwhjartnxchmxugxqlodwijoar",
                              width: 44.3,
                              paddingLeft: 90,
                              paddingLeftSuffix: "px",
                              padding: 15,
                              tabsState: "",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "",
                              tabletWidth: 50.4,
                              mobilePaddingRight: 30,
                              mobilePaddingRightSuffix: "px",
                              mobilePadding: 0,
                              mobilePaddingLeft: 20,
                              mobilePaddingLeftSuffix: "px",
                              tabletPaddingRight: 15,
                              tabletPaddingRightSuffix: "px",
                              tabletPadding: 15,
                              tabletPaddingLeft: 20,
                              tabletPaddingLeftSuffix: "px",
                              className: "",
                              borderStyle: "solid",
                              tempBorderStyle: "solid",
                              borderWidthType: "grouped",
                              borderWidth: 0,
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              tempBorderWidth: 4,
                              tempBorderTopWidth: 4,
                              tempBorderRightWidth: 4,
                              tempBorderBottomWidth: 4,
                              tempBorderLeftWidth: 4,
                              borderRadiusType: "grouped",
                              borderRadius: 0,
                              borderTopLeftRadius: 0,
                              borderTopRightRadius: 0,
                              borderBottomRightRadius: 0,
                              borderBottomLeftRadius: 0,
                              tempBorderRadius: 0,
                              tempBorderTopLeftRadius: 0,
                              tempBorderTopRightRadius: 0,
                              tempBorderBottomRightRadius: 0,
                              tempBorderBottomLeftRadius: 0,
                              bgColorType: "solid",
                              gradientActivePointer: "startPointer",
                              gradientStartPointer: 0,
                              gradientFinishPointer: 100,
                              gradientType: "linear",
                              gradientLinearDegree: 90,
                              gradientRadialDegree: 90,
                              bgColorHex: "#000000",
                              bgColorOpacity: 0,
                              bgColorPalette: "",
                              tempBgColorOpacity: 1,
                              tempBgColorPalette: "",
                              gradientColorHex: "#009900",
                              gradientColorOpacity: 1,
                              gradientColorPalette: "",
                              tempGradientColorOpacity: 1,
                              tempGradientColorPalette: "",
                              borderColorHex: "#66738d",
                              borderColorOpacity: 0,
                              borderColorPalette: "",
                              tempBorderColorOpacity: 1,
                              tempBorderColorPalette: "",
                              hoverTransition: 50,
                              verticalAlign: "top",
                              paddingType: "ungrouped",
                              paddingTop: 5,
                              paddingRight: 15,
                              paddingBottom: 5,
                              paddingSuffix: "px",
                              paddingTopSuffix: "px",
                              paddingRightSuffix: "px",
                              paddingBottomSuffix: "px",
                              marginType: "grouped",
                              margin: 0,
                              marginTop: 0,
                              marginRight: 0,
                              marginBottom: 0,
                              marginLeft: 0,
                              marginSuffix: "px",
                              marginTopSuffix: "px",
                              marginRightSuffix: "px",
                              marginBottomSuffix: "px",
                              marginLeftSuffix: "px",
                              boxShadow: "",
                              boxShadowColorHex: "#000000",
                              boxShadowColorOpacity: 0,
                              boxShadowColorPalette: 0,
                              boxShadowBlur: 0,
                              boxShadowSpread: 0,
                              boxShadowVertical: 0,
                              boxShadowHorizontal: 0,
                              tempBoxShadowColorPalette: "",
                              tempBoxShadowColorOpacity: 1,
                              customClassName: "",
                              customCSS: "",
                              tabletPaddingType: "ungrouped",
                              tabletPaddingTop: 5,
                              tabletPaddingBottom: 5,
                              tabletPaddingSuffix: "px",
                              tabletPaddingTopSuffix: "px",
                              tabletPaddingBottomSuffix: "px",
                              tempTabletPadding: 10,
                              tempTabletPaddingTop: 10,
                              tempTabletPaddingRight: 10,
                              tempTabletPaddingBottom: 10,
                              tempTabletPaddingLeft: 10,
                              tabletMarginType: "ungrouped",
                              tabletMargin: 0,
                              tabletMarginTop: 0,
                              tabletMarginRight: 0,
                              tabletMarginBottom: 0,
                              tabletMarginLeft: 0,
                              tabletMarginSuffix: "px",
                              tabletMarginTopSuffix: "px",
                              tabletMarginRightSuffix: "px",
                              tabletMarginBottomSuffix: "px",
                              tabletMarginLeftSuffix: "px",
                              mobilePaddingType: "ungrouped",
                              mobilePaddingTop: 0,
                              mobilePaddingBottom: 0,
                              mobilePaddingSuffix: "px",
                              mobilePaddingTopSuffix: "px",
                              mobilePaddingBottomSuffix: "px",
                              tempMobilePadding: 10,
                              tempMobilePaddingTop: 10,
                              tempMobilePaddingRight: 10,
                              tempMobilePaddingBottom: 10,
                              tempMobilePaddingLeft: 10,
                              mobileMarginType: "ungrouped",
                              mobileMargin: 10,
                              mobileMarginTop: 10,
                              mobileMarginRight: 0,
                              mobileMarginBottom: 10,
                              mobileMarginLeft: 0,
                              mobileMarginSuffix: "px",
                              mobileMarginTopSuffix: "px",
                              mobileMarginRightSuffix: "px",
                              mobileMarginBottomSuffix: "px",
                              mobileMarginLeftSuffix: "px",
                              tempBoxShadow: "on",
                            },
                          },
                        ],
                        _id: "kmohwfibpjjfkkwtsuurkoeianbfqlqvhkzb",
                      },
                    },
                  ],
                  _id: "xtgkangvdnorlokbhdwsfroztjnxielgovdb",
                  paddingType: "ungrouped",
                  paddingTop: 78,
                  paddingBottom: 49,
                  padding: 75,
                  tabsState: "tabNormal",
                  tabsCurrentElement: "tabCurrentElement",
                  tabsColor: "tabOverlay",
                  tabletPaddingType: "ungrouped",
                  tabletPaddingTop: 15,
                  tabletPaddingBottom: 15,
                  tabletPadding: 50,
                  mobilePaddingType: "ungrouped",
                  mobilePaddingTop: 15,
                  mobilePaddingBottom: 51,
                  mobilePadding: 25,
                },
              },
            ],
            _id: "szbiowvgynqwtxvtslzmqawqexdjqllxecwr",
            _thumbnailSrc: 200377,
            _thumbnailWidth: 600,
            _thumbnailHeight: 261,
            _thumbnailTime: 1631622950234,
            anchorName: "services",
          },
          blockId: "Blank000Light",
        },
        {
          type: "Section",
          value: {
            _styles: ["section"],
            items: [
              {
                type: "SectionItem",
                value: {
                  _styles: ["section-item"],
                  items: [
                    {
                      type: "Row",
                      value: {
                        _styles: ["row", "hide-row-borders", "padding-0"],
                        items: [
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "acxxicxxlmpzjpvqftsvqlzjfnqraoaavgcn",
                                          text: '<p class="brz-lh-lg-1 brz-lh-sm-im-1 brz-lh-xs-im-1 brz-ff-rozha_one brz-fw-lg-400 brz-fw-sm-im-400 brz-fw-xs-im-400 brz-fs-lg-290 brz-fs-sm-im-289 brz-fs-xs-im-288 brz-ls-sm-im-0 brz-ls-xs-im-0 brz-ls-lg-m_1_5"><span class="brz-cp-color6">â</span></p>',
                                        },
                                      },
                                    ],
                                    _id: "nhodyvxuvqxhtvqeaolnowzgivqpagdzlqhw",
                                    marginBottomSuffix: "px",
                                    marginBottom: -150,
                                    margin: 0,
                                    marginSuffix: "px",
                                    tabletMarginBottom: -150,
                                    tabletMargin: 0,
                                    tabletMarginSuffix: "px",
                                    marginTopSuffix: "px",
                                    mobileMarginTop: 10,
                                    mobileMargin: 0,
                                    mobileMarginSuffix: "px",
                                    mobileMarginBottom: -170,
                                  },
                                },
                                {
                                  type: "Row",
                                  value: {
                                    _styles: ["row", "hide-row-borders", "padding-0"],
                                    items: [
                                      {
                                        type: "Column",
                                        value: {
                                          _styles: ["column"],
                                          items: [
                                            {
                                              type: "Wrapper",
                                              value: {
                                                _styles: ["wrapper", "wrapper--richText"],
                                                items: [
                                                  {
                                                    type: "RichText",
                                                    value: {
                                                      _styles: ["richText"],
                                                      _id: "wxihhdjtdmgbvjyhceqqkfveffccirfvsmgh",
                                                      text: '<h4 class="brz-tp-heading4"><span class="brz-cp-color2">The selection couldn\'t be clearer or purchase from anyone else thanks! the store. </span><em class="brz-cp-color3">Thank you!</em><em class="brz-cp-color2">&nbsp;</em></h4>',
                                                    },
                                                  },
                                                ],
                                                _id: "buadeljlamzvuewsvfjaompxgbbwwzlwvmla",
                                              },
                                            },
                                            {
                                              type: "Wrapper",
                                              value: {
                                                _styles: ["wrapper", "wrapper--richText"],
                                                items: [
                                                  {
                                                    type: "RichText",
                                                    value: {
                                                      _styles: ["richText"],
                                                      _id: "llbtdqqmiwequvulpxaapbkgmezltncxbnuc",
                                                      text: '<p class="brz-tp-subtitle"><span class="brz-cp-color5">Matt Bindors</span></p>',
                                                    },
                                                  },
                                                ],
                                                _id: "wkmkujscphpitkuomrkmwnclnpixhtxvxnys",
                                                marginTopSuffix: "px",
                                                marginTop: 0,
                                                margin: 0,
                                                marginSuffix: "px",
                                                mobileMarginTop: 0,
                                                mobileMargin: 0,
                                                mobileMarginSuffix: "px",
                                                tabletMarginTop: 0,
                                                tabletMargin: 0,
                                                tabletMarginSuffix: "px",
                                              },
                                            },
                                            {
                                              type: "Wrapper",
                                              value: {
                                                _styles: ["wrapper", "wrapper--spacer"],
                                                items: [
                                                  {
                                                    type: "Spacer",
                                                    value: {
                                                      _styles: ["spacer"],
                                                      _id: "izovqwulpwpxquzlbgytigvuecqujvowctgw",
                                                      tabletHeight: 15,
                                                      mobileHeight: 30,
                                                      height: 60,
                                                    },
                                                  },
                                                ],
                                                _id: "ikhdfhgltbrbtbrdfuorwyinspqqsczpsmnl",
                                                showOnTablet: "on",
                                                showOnMobile: "on",
                                              },
                                            },
                                            {
                                              type: "Wrapper",
                                              value: {
                                                _styles: ["wrapper", "wrapper--richText"],
                                                items: [
                                                  {
                                                    type: "RichText",
                                                    value: {
                                                      _styles: ["richText"],
                                                      _id: "jsevnpyowgtdwlhlppcxozpxonmkwmxdcgha",
                                                      text: '<h4 class="brz-tp-heading4"><span class="brz-cp-color2">We highly recommend and very professional a big thanks to use. </span><em class="brz-cp-color3">Lovely work</em><em class="brz-cp-color2"> </em><span class="brz-cp-color2">and fast!</span></h4>',
                                                    },
                                                  },
                                                ],
                                                _id: "cbqptfngbktoksbmmllxmyfbrwmjdehustaf",
                                              },
                                            },
                                            {
                                              type: "Wrapper",
                                              value: {
                                                _styles: ["wrapper", "wrapper--richText"],
                                                items: [
                                                  {
                                                    type: "RichText",
                                                    value: {
                                                      _styles: ["richText"],
                                                      _id: "ieonbcusoxndeijclilvsqrcvcpnexqkvapg",
                                                      text: '<p class="brz-tp-subtitle"><span class="brz-cp-color5">Rebecca Jenkins</span></p>',
                                                    },
                                                  },
                                                ],
                                                _id: "hnqybjgtjarfapsnqqqqyjgpyaqrzmmebkcb",
                                                marginTopSuffix: "px",
                                                marginTop: 0,
                                                margin: 0,
                                                marginSuffix: "px",
                                                mobileMarginTop: 0,
                                                mobileMargin: 0,
                                                mobileMarginSuffix: "px",
                                                tabletMarginTop: 0,
                                                tabletMargin: 0,
                                                tabletMarginSuffix: "px",
                                              },
                                            },
                                            {
                                              type: "Wrapper",
                                              value: {
                                                _styles: ["wrapper", "wrapper--spacer"],
                                                items: [
                                                  {
                                                    type: "Spacer",
                                                    value: {
                                                      _styles: ["spacer"],
                                                      _id: "psfcrdvjllsuwquzmxngheursiftipnvthft",
                                                      tabletHeight: 15,
                                                      mobileHeight: 30,
                                                      height: 60,
                                                      className: "",
                                                    },
                                                  },
                                                ],
                                                _id: "ehmmmzfgthclmpekdebmyetlskenibrzzmgf",
                                                showOnTablet: "on",
                                                showOnMobile: "on",
                                                className: "",
                                                horizontalAlign: "center",
                                                paddingType: "grouped",
                                                padding: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                paddingSuffix: "px",
                                                paddingTopSuffix: "px",
                                                paddingRightSuffix: "px",
                                                paddingBottomSuffix: "px",
                                                paddingLeftSuffix: "px",
                                                marginType: "ungrouped",
                                                margin: 0,
                                                marginTop: 10,
                                                marginRight: 0,
                                                marginBottom: 10,
                                                marginLeft: 0,
                                                marginSuffix: "px",
                                                marginTopSuffix: "px",
                                                marginRightSuffix: "px",
                                                marginBottomSuffix: "px",
                                                marginLeftSuffix: "px",
                                                customClassName: "",
                                                tabletPaddingType: "grouped",
                                                tabletPadding: 0,
                                                tabletPaddingTop: 0,
                                                tabletPaddingRight: 0,
                                                tabletPaddingBottom: 0,
                                                tabletPaddingLeft: 0,
                                                tabletPaddingSuffix: "px",
                                                tabletPaddingTopSuffix: "px",
                                                tabletPaddingRightSuffix: "px",
                                                tabletPaddingBottomSuffix: "px",
                                                tabletPaddingLeftSuffix: "px",
                                                tabletMarginType: "ungrouped",
                                                tabletMargin: 0,
                                                tabletMarginTop: 10,
                                                tabletMarginRight: 0,
                                                tabletMarginBottom: 10,
                                                tabletMarginLeft: 0,
                                                tabletMarginSuffix: "px",
                                                tabletMarginTopSuffix: "px",
                                                tabletMarginRightSuffix: "px",
                                                tabletMarginBottomSuffix: "px",
                                                tabletMarginLeftSuffix: "px",
                                                mobilePaddingType: "grouped",
                                                mobilePadding: 0,
                                                mobilePaddingTop: 0,
                                                mobilePaddingRight: 0,
                                                mobilePaddingBottom: 0,
                                                mobilePaddingLeft: 0,
                                                mobilePaddingSuffix: "px",
                                                mobilePaddingTopSuffix: "px",
                                                mobilePaddingRightSuffix: "px",
                                                mobilePaddingBottomSuffix: "px",
                                                mobilePaddingLeftSuffix: "px",
                                                mobileMarginType: "ungrouped",
                                                mobileMargin: 0,
                                                mobileMarginTop: 10,
                                                mobileMarginRight: 0,
                                                mobileMarginBottom: 10,
                                                mobileMarginLeft: 0,
                                                mobileMarginSuffix: "px",
                                                mobileMarginTopSuffix: "px",
                                                mobileMarginRightSuffix: "px",
                                                mobileMarginBottomSuffix: "px",
                                                mobileMarginLeftSuffix: "px",
                                              },
                                            },
                                            {
                                              type: "Wrapper",
                                              value: {
                                                _styles: ["wrapper", "wrapper--richText"],
                                                items: [
                                                  {
                                                    type: "RichText",
                                                    value: {
                                                      _styles: ["richText"],
                                                      _id: "gjvhexskqyfkmvuvtaddojcvbsbmcyskvkge",
                                                      text: '<h4 class="brz-tp-heading4"><span class="brz-cp-color2">We got to work with my purchase the team was the best talent ever!</span></h4>',
                                                    },
                                                  },
                                                ],
                                                _id: "lhizkfmrjylhbrnpzzjeiqazpyvofnniiqhk",
                                              },
                                            },
                                            {
                                              type: "Wrapper",
                                              value: {
                                                _styles: ["wrapper", "wrapper--richText"],
                                                items: [
                                                  {
                                                    type: "RichText",
                                                    value: {
                                                      _styles: ["richText"],
                                                      _id: "pjxkpuwyblopdkridcsfzvjvdflohoqrhosc",
                                                      text: '<p class="brz-tp-subtitle"><span class="brz-cp-color5">Sylvian Mastrich</span></p>',
                                                    },
                                                  },
                                                ],
                                                _id: "kimzaoktekzjxylowgpzqknodimowuidnqsx",
                                                marginTopSuffix: "px",
                                                marginTop: 0,
                                                margin: 0,
                                                marginSuffix: "px",
                                                mobileMarginTop: 0,
                                                mobileMargin: 0,
                                                mobileMarginSuffix: "px",
                                                tabletMarginTop: 0,
                                                tabletMargin: 0,
                                                tabletMarginSuffix: "px",
                                              },
                                            },
                                          ],
                                          _id: "fhgvujljeasoyasksxrkwnokeztjwfbuhknl",
                                          width: 100,
                                          marginType: "ungrouped",
                                          marginLeft: 80,
                                          marginLeftSuffix: "px",
                                          margin: 0,
                                          tabsState: "tabNormal",
                                          tabsCurrentElement: "tabCurrentElement",
                                          tabsColor: "tabOverlay",
                                          tabletMarginLeft: 30,
                                          tabletMarginLeftSuffix: "px",
                                          tabletMargin: 0,
                                          tabletMarginRight: 0,
                                          tabletMarginRightSuffix: "px",
                                          tabletPaddingRight: 30,
                                          tabletPaddingRightSuffix: "px",
                                          tabletPadding: 15,
                                        },
                                      },
                                    ],
                                    _id: "xzhfblwhrdlfpvtrsapsxqdqkutoeczuszsx",
                                  },
                                },
                              ],
                              _id: "xkxlefpqgkjxztdlxvehweehqsgzmjhvhffd",
                              width: 53,
                              tabletWidth: 66.1,
                              tabsState: "tabNormal",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "tabOverlay",
                              mobilePaddingRight: 90,
                              mobilePaddingRightSuffix: "px",
                              mobilePadding: 0,
                              mobilePaddingLeft: 20,
                              mobilePaddingLeftSuffix: "px",
                              tabletPaddingRight: 20,
                              tabletPaddingRightSuffix: "px",
                              tabletPadding: 15,
                              tabletPaddingTop: 5,
                              tabletPaddingTopSuffix: "px",
                              tabletPaddingLeft: 12,
                              tabletPaddingLeftSuffix: "px",
                              mobilePaddingType: "ungrouped",
                            },
                          },
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--spacer"],
                                    items: [
                                      {
                                        type: "Spacer",
                                        value: {
                                          _styles: ["spacer"],
                                          _id: "xtuwpeyvhkjvavqasfujhjjrprtcvjubsmrt",
                                          mobileHeight: 10,
                                          tabletHeight: 38,
                                        },
                                      },
                                    ],
                                    _id: "mnnlqmmcghcvuuwslmhaiawuxtawhesdtwzd",
                                    showOnMobile: "off",
                                  },
                                },
                              ],
                              _id: "fjpjfjhyikavdkiugizlvepegufijxmmhzeq",
                              width: 47,
                              tabletWidth: 41,
                              showOnMobile: "off",
                              tabsState: "tabNormal",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "tabOverlay",
                            },
                          },
                        ],
                        _id: "pfnhxowcyuwhtcyzxyrwkixusybemrwoxtez",
                      },
                    },
                  ],
                  _id: "xapamuhkzightycenisnanysxojuursngnkb",
                  tabsCurrentElement: "tabCurrentElement",
                  tabsState: "tabNormal",
                  tabsColor: "tabOverlay",
                  bgImageWidth: 1920,
                  bgImageHeight: 1200,
                  bgImageSrc: "1dc4b0f490e5958178e0308dc53284a4.jpg",
                  bgColorOpacity: 0,
                  tempBgColorOpacity: 1,
                  borderRadius: 0,
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  tempBorderTopLeftRadius: 0,
                  tempBorderTopRightRadius: 0,
                  tempBorderBottomLeftRadius: 0,
                  tempBorderBottomRightRadius: 0,
                  bgPositionX: 88,
                  bgPositionY: 52,
                  paddingType: "ungrouped",
                  paddingTop: 35,
                  paddingBottom: 215,
                  padding: 75,
                  tabletBgPositionX: 59,
                  tabletBgPositionY: 31,
                  tabletBorderRadius: 0,
                  tabletBorderTopLeftRadius: 0,
                  tabletBorderTopRightRadius: 0,
                  tabletBorderBottomLeftRadius: 0,
                  tabletBorderBottomRightRadius: 0,
                  tempTabletBorderTopLeftRadius: 0,
                  tempTabletBorderTopRightRadius: 0,
                  tempTabletBorderBottomLeftRadius: 0,
                  tempTabletBorderBottomRightRadius: 0,
                  tabletPaddingType: "ungrouped",
                  tabletPaddingTop: 50,
                  tabletPaddingBottom: 15,
                  tabletPadding: 50,
                  mobilePaddingType: "ungrouped",
                  mobilePaddingTop: 25,
                  mobilePaddingBottom: 15,
                  mobilePadding: 25,
                  mobileBgPositionX: 67,
                  mobileBgPositionY: 30,
                  mobileBorderRadius: 0,
                  mobileBorderTopLeftRadius: 0,
                  mobileBorderTopRightRadius: 0,
                  mobileBorderBottomLeftRadius: 0,
                  mobileBorderBottomRightRadius: 0,
                  tempMobileBorderTopLeftRadius: 0,
                  tempMobileBorderTopRightRadius: 0,
                  tempMobileBorderBottomLeftRadius: 0,
                  tempMobileBorderBottomRightRadius: 0,
                  mobileBgColorPalette: "color8",
                  tempMobileBgColorPalette: "color8",
                  mobileBgColorOpacity: 0.64,
                  mobileBgColorHex: "#ffffff",
                  tempMobileBgColorOpacity: 0.64,
                },
              },
            ],
            _id: "ryhpbofaeaujqafdjzekcjittrxpijvnrrav",
            _thumbnailSrc: 200373,
            _thumbnailWidth: 600,
            _thumbnailHeight: 333,
            _thumbnailTime: 1631622953631,
            anchorName: "testimonails",
          },
          blockId: "Blank000Light",
        },
        {
          type: "Section",
          value: {
            _styles: ["section"],
            items: [
              {
                type: "SectionItem",
                value: {
                  _styles: ["section-item"],
                  items: [
                    {
                      type: "Row",
                      value: {
                        _styles: ["row", "hide-row-borders", "padding-0"],
                        items: [
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "itappztjuamvlxodcyjmvmzfebqbcvcsiccs",
                                          text: '<p class="brz-tp-abovetitle"><strong class="brz-cp-color4">CONTACT</strong></p>',
                                        },
                                      },
                                    ],
                                    _id: "ploagnfzbrnvmhiqprjimwgjqvwobhkciydo",
                                    marginBottomSuffix: "px",
                                    marginBottom: 0,
                                    margin: 0,
                                    marginSuffix: "px",
                                    mobileMarginBottom: 0,
                                    mobileMargin: 0,
                                    mobileMarginSuffix: "px",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "jzjbykuazxmnatultqyylicqqnxcatnefrca",
                                          text: '<h1 class="brz-tp-heading1"><span class="brz-cp-color2">Contact us</span></h1>',
                                        },
                                      },
                                    ],
                                    _id: "mnotewjksmfcfwvxyrgcuhbrsshfwllcluwr",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "ezkcanfzevajkdojxcktpeczcclucazdyola",
                                          text: '<p class="brz-tp-paragraph"><span class="brz-cp-color2">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</span></p>',
                                        },
                                      },
                                    ],
                                    _id: "szymckbdowtsyrgdntyucdtaoxddpuuobxpp",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--spacer"],
                                    items: [
                                      {
                                        type: "Spacer",
                                        value: {
                                          _styles: ["spacer"],
                                          _id: "pxzqcomkbaypghamqclxxwpnvqrebggfrngp",
                                          height: 15,
                                          tabletHeight: 10,
                                        },
                                      },
                                    ],
                                    _id: "ibwrkvalzlgnxqvjbcawiylzkoqhtsmrbwzw",
                                    showOnTablet: "on",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--iconText"],
                                    items: [
                                      {
                                        type: "Form2",
                                        value: {
                                          _styles: ["form"],
                                          items: [
                                            {
                                              type: "Form2Fields",
                                              value: {
                                                items: [
                                                  {
                                                    type: "Form2Field",
                                                    value: {
                                                      type: "Text",
                                                      label: "Your Name",
                                                      required: "on",
                                                      options: ["Option 1", "Option 2"],
                                                      _id: "mimzwtumhnequciecknhcqulwdksikbxpdwu",
                                                      placeholder: "Your Name",
                                                    },
                                                  },
                                                  {
                                                    type: "Form2Field",
                                                    value: {
                                                      type: "Email",
                                                      label: "Your Email",
                                                      required: "off",
                                                      options: ["Option 1", "Option 2"],
                                                      _id: "csnlavyiyolrpyqqzxfhnvjyjezpdwftyzfo",
                                                      placeholder: "Your Email",
                                                    },
                                                  },
                                                  {
                                                    type: "Form2Field",
                                                    value: {
                                                      type: "Paragraph",
                                                      label: "Message",
                                                      required: "off",
                                                      options: ["Option 1", "Option 2"],
                                                      _id: "kuutftbtaijiawxtunldsiikepscirixmbke",
                                                      placeholder: "Message",
                                                    },
                                                  },
                                                ],
                                                _id: "ssmdgupwnigxxmvkmkphpxweuzvscrpyntlo",
                                                fontStyle: "heading6",
                                                tabsState: "",
                                                tabsColor: "",
                                                borderColorPalette: "color7",
                                                tempBorderColorPalette: "color7",
                                                borderColorOpacity: 1,
                                                borderStyle: "solid",
                                                borderWidth: 1,
                                                borderTopWidth: 1,
                                                borderRightWidth: 1,
                                                borderBottomWidth: 1,
                                                borderLeftWidth: 1,
                                                tempBorderTopWidth: 1,
                                                tempBorderRightWidth: 1,
                                                tempBorderBottomWidth: 1,
                                                tempBorderLeftWidth: 1,
                                                mobileSize: "medium",
                                                mobilePaddingTop: 14,
                                                mobilePaddingRight: 24,
                                                mobilePaddingBottom: 14,
                                                mobilePaddingLeft: 24,
                                                mobileFontStyle: "",
                                                mobileFontFamily: "noto_serif",
                                                mobileFontFamilyType: "google",
                                                mobileFontSize: 16,
                                                mobileLineHeight: 1.5,
                                                mobileLetterSpacing: 0,
                                                mobileFontWeight: 400,
                                              },
                                            },
                                            {
                                              type: "Button",
                                              value: {
                                                _styles: ["button", "submit"],
                                                _id: "zqqcpuktbqrzsyaoglpcfbyctbcomwzawaln",
                                                tabsState: "",
                                                tabsColor: "",
                                                colorPalette: "color3",
                                                colorOpacity: 1,
                                                fontStyle: "heading5",
                                                fillType: "default",
                                                tempFillType: "filled",
                                                paddingRL: 0,
                                                paddingRight: 0,
                                                paddingLeft: 0,
                                                paddingTB: 11,
                                                paddingTop: 11,
                                                paddingBottom: 11,
                                                borderRadiusType: "",
                                                borderRadius: 2,
                                                borderWidth: 0,
                                                borderColorOpacity: 0,
                                                borderColorPalette: "",
                                                bgColorOpacity: 0,
                                                bgColorPalette: "",
                                                gradientColorOpacity: 0,
                                                gradientColorPalette: "",
                                                hoverBgColorOpacity: 0,
                                                hoverBorderColorOpacity: 0,
                                                hoverColorPalette: "color5",
                                                hoverColorOpacity: 1,
                                                text: "Send Message",
                                                size: "small",
                                                fontSize: 11,
                                                tempPaddingTB: 11,
                                                tempPaddingTop: 11,
                                                tempPaddingBottom: 11,
                                                tempPaddingRL: 42,
                                                tempPaddingRight: 42,
                                                tempPaddingLeft: 42,
                                                tabletSize: "custom",
                                                tabletFontSize: 16,
                                                tabletPaddingTB: 14,
                                                tabletPaddingTop: 14,
                                                tabletPaddingBottom: 14,
                                                tempTabletPaddingTB: 19,
                                                tempTabletPaddingTop: 14,
                                                tempTabletPaddingBottom: 14,
                                                tabletPaddingRL: 0,
                                                tabletPaddingRight: 0,
                                                tabletPaddingLeft: 0,
                                                tempTabletPaddingRL: 26,
                                                tempTabletPaddingRight: 0,
                                                tempTabletPaddingLeft: 0,
                                                tabletBorderRadius: 2,
                                                tabletLineHeight: 1.6,
                                                tabletLetterSpacing: 0,
                                                tabletFontWeight: 600,
                                                tabletFontStyle: "",
                                                mobileFontSize: 17,
                                                mobileLineHeight: 1.6,
                                                mobileLetterSpacing: 0,
                                                mobileFontWeight: 600,
                                                mobileFontStyle: "",
                                              },
                                            },
                                          ],
                                          _id: "ovijerwokrblonianvsvoognfdhfcqmkkpzb",
                                          horizontalAlign: "right",
                                          submitWidth: 30,
                                          padding: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          tabletSubmitWidth: 35,
                                          mobilePadding: 12,
                                          mobilePaddingRight: 12,
                                          mobilePaddingBottom: 12,
                                          mobilePaddingLeft: 12,
                                          mobileSubmitWidth: 61,
                                          mobileHorizontalAlign: "center",
                                        },
                                      },
                                    ],
                                    _id: "elhhccnprjwtgvluntsltkwikdgtilfebzlm",
                                  },
                                },
                              ],
                              _id: "bvrqsxuaunqjuxpcrkxzqzbqsqhdybbwacrc",
                              width: 70,
                              tabletWidth: 100,
                              mobileWidth: 100,
                              tabsState: "tabNormal",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "tabOverlay",
                              tabletPaddingLeft: 50,
                              tabletPaddingLeftSuffix: "px",
                              tabletPadding: 15,
                              tabletPaddingRight: 50,
                              tabletPaddingRightSuffix: "px",
                              mobilePaddingLeft: 20,
                              mobilePaddingLeftSuffix: "px",
                              mobilePadding: 0,
                              mobilePaddingRight: 20,
                              mobilePaddingRightSuffix: "px",
                            },
                          },
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--spacer"],
                                    items: [
                                      {
                                        type: "Spacer",
                                        value: {
                                          _styles: ["spacer"],
                                          _id: "wywnbrlzqizrghrhscjticamplesihmmtqsp",
                                          mobileHeight: 10,
                                        },
                                      },
                                    ],
                                    _id: "qslrcwjmxikaszqosctrljoadbvqfpnjfruh",
                                    showOnTablet: "off",
                                    showOnMobile: "off",
                                  },
                                },
                              ],
                              _id: "aqdfcjvaggtopaeikrvtepemcdypigscefpr",
                              width: 30,
                              tabletWidth: 27,
                              showOnTablet: "off",
                              tabsState: "tabNormal",
                              tabsCurrentElement: "tabCurrentElement",
                              tabsColor: "tabOverlay",
                              showOnMobile: "off",
                            },
                          },
                        ],
                        _id: "izvdfglkxxjmltnuorphxrzkzcwyunkwhkgh",
                      },
                    },
                  ],
                  _id: "zqpboegnopykefiqfbnvpfjuwdkmnndddqxq",
                  paddingType: "ungrouped",
                  paddingTop: 15,
                  paddingBottom: 60,
                  padding: 75,
                  containerSize: 85,
                  tabsState: "tabNormal",
                  tabsCurrentElement: "tabCurrentElement",
                  tabsColor: "tabOverlay",
                  tabletPaddingType: "ungrouped",
                  tabletPaddingTop: 15,
                  tabletPaddingBottom: 15,
                  tabletPadding: 50,
                  mobilePaddingType: "ungrouped",
                  mobilePaddingTop: 15,
                  mobilePaddingBottom: 15,
                  mobilePadding: 25,
                },
              },
            ],
            _id: "swacsogvifgnvxkflgxoozowylvjbsmiocgx",
            _thumbnailSrc: 200390,
            _thumbnailWidth: 600,
            _thumbnailHeight: 219,
            _thumbnailTime: 1631622956210,
            anchorName: "contact",
          },
          blockId: "Blank000Light",
        },
        {
          type: "Section",
          value: {
            _styles: ["section"],
            items: [
              {
                type: "SectionItem",
                value: {
                  _styles: ["section-item"],
                  items: [
                    {
                      type: "Row",
                      value: {
                        _styles: ["row", "hide-row-borders", "padding-0"],
                        items: [
                          {
                            type: "Column",
                            value: {
                              _styles: ["column"],
                              items: [
                                {
                                  type: "Cloneable",
                                  value: {
                                    _styles: ["wrapper-clone", "wrapper-clone--icon"],
                                    items: [
                                      {
                                        type: "Icon",
                                        value: {
                                          _styles: ["icon"],
                                          _id: "sotdlhwclrfuysnmwkcvbtztgsuzxinbsriu",
                                          size: "custom",
                                          customSize: 26,
                                          borderRadius: 0,
                                          name: "logo-facebook",
                                          type: "glyph",
                                          colorPalette: "color2",
                                          colorOpacity: 1,
                                          hoverColorHex: "#b26889",
                                          hoverColorOpacity: 1,
                                          hoverColorPalette: "color3",
                                        },
                                      },
                                      {
                                        type: "Icon",
                                        value: {
                                          _styles: ["icon"],
                                          _id: "lbhrjdjnekbquwzjbuaeyhuhcequarayjbpx",
                                          size: "custom",
                                          customSize: 26,
                                          borderRadius: 0,
                                          name: "logo-instagram",
                                          type: "glyph",
                                          colorPalette: "color2",
                                          colorOpacity: 1,
                                          hoverColorHex: "#b26889",
                                          hoverColorOpacity: 1,
                                          hoverColorPalette: "color3",
                                        },
                                      },
                                    ],
                                    _id: "wceevnyrmiieflnhaqqrnwvyldkihamxmsll",
                                    itemPadding: 40,
                                    itemPaddingRight: 40,
                                    itemPaddingLeft: 40,
                                    horizontalAlign: "center",
                                    marginBottomSuffix: "px",
                                    marginBottom: -29,
                                    margin: 0,
                                    marginSuffix: "px",
                                    tabletMarginBottom: 0,
                                    tabletMargin: 0,
                                    tabletMarginSuffix: "px",
                                    tabletMarginBottomSuffix: "px",
                                    tabletMarginTopSuffix: "px",
                                    tabletMarginTop: 0,
                                    tabletMarginType: "grouped",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--spacer"],
                                    items: [
                                      {
                                        type: "Spacer",
                                        value: {
                                          _styles: ["spacer"],
                                          _id: "xyynqoqrgvmybzqgvoxcaloflppxykilesch",
                                          height: 30,
                                          tabletHeight: 10,
                                          mobileHeight: 10,
                                        },
                                      },
                                    ],
                                    _id: "epixzjiyzraaflkvbksxywfqkjnzptgpodvx",
                                    showOnTablet: "off",
                                    showOnMobile: "on",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "zxsgsfnugicaepfgrotsfrcmyrkniddwwjxq",
                                          text: '<h2 class="brz-text-lg-center brz-tp-heading2"><a data-href="%7B%22type%22%3A%22anchor%22%2C%22anchor%22%3A%22%23essjeveederfnmzpbppolbjnotxmbqmgufjy%22%2C%22external%22%3A%22%22%2C%22externalBlank%22%3A%22off%22%2C%22externalRel%22%3A%22off%22%2C%22externalType%22%3A%22external%22%2C%22population%22%3A%22%22%2C%22popup%22%3A%22%22%7D" class="brz-cp-color8 link--anchor">Get a quotation for your project</a></h2>',
                                        },
                                      },
                                    ],
                                    _id: "epyaoqutkjjsswgncfweabxtvrwgxihrbjca",
                                    mobilePaddingType: "ungrouped",
                                    paddingRightSuffix: "px",
                                    mobilePaddingRight: 30,
                                    mobilePadding: 0,
                                    mobilePaddingSuffix: "px",
                                    paddingLeftSuffix: "px",
                                    mobilePaddingLeft: 30,
                                    tabletMarginTopSuffix: "px",
                                    tabletMarginTop: 12,
                                    tabletMargin: 0,
                                    tabletMarginSuffix: "px",
                                  },
                                },
                                {
                                  type: "Wrapper",
                                  value: {
                                    _styles: ["wrapper", "wrapper--richText"],
                                    items: [
                                      {
                                        type: "RichText",
                                        value: {
                                          _styles: ["richText"],
                                          _id: "mfcdcxhcpyrlevdccaaahbfukzwdtphoashe",
                                          text: '<p class="brz-text-lg-center brz-tp-subtitle"><span class="brz-cp-color2">Agency Landing Page Â© Made with </span><a data-href="" class="link--external brz-cp-color2">love</a></p>',
                                        },
                                      },
                                    ],
                                    _id: "igfwcsxjkmxlkfvjtildilwsgvgjyzgdmdac",
                                  },
                                },
                              ],
                              _id: "rdvimgzmfsxngapsajvyzrrkrztdpmsglfxt",
                              width: 100,
                            },
                          },
                        ],
                        _id: "dmxpfnutebzqopgjzhweguuvsefrqlbveean",
                      },
                    },
                  ],
                  _id: "dftxmkljqejugatmmawpbnrakngxicladsuy",
                  tabsColor: "tabOverlay",
                  bgColorPalette: "color4",
                  tempBgColorPalette: "color4",
                  bgColorOpacity: 0.8,
                  borderRadius: 0,
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  tempBorderTopLeftRadius: 0,
                  tempBorderTopRightRadius: 0,
                  tempBorderBottomLeftRadius: 0,
                  tempBorderBottomRightRadius: 0,
                  tabsState: "tabNormal",
                  tabsCurrentElement: "tabCurrentElement",
                  paddingType: "ungrouped",
                  paddingTop: 143,
                  paddingBottom: 100,
                  padding: 75,
                  shapeTopType: "23",
                  shapeTopHorizontal: "on",
                  shapeTopHeight: 70,
                  shapeTopHeightSuffix: "px",
                  shapeTopColorHex: "#ffffff",
                  shapeTopColorOpacity: 1,
                  shapeTopColorPalette: "",
                  tabletPaddingType: "ungrouped",
                  tabletPaddingTop: 89,
                  tabletPaddingBottom: 50,
                  tabletPadding: 50,
                  mobilePaddingType: "ungrouped",
                  mobilePaddingTop: 56,
                  mobilePaddingBottom: 25,
                  mobilePadding: 25,
                  bgColorHex: "#cb973d",
                  tempBgColorOpacity: 0.8,
                  tabletShapeTopHeight: 55,
                  tabletShapeTopHeightSuffix: "px",
                  mobileShapeTopHeight: 39,
                  mobileShapeTopHeightSuffix: "px",
                },
              },
            ],
            _id: "lsppqgvlwpfbgjqhgklbajkgruoxdxmybitp",
            _thumbnailSrc: 200391,
            _thumbnailWidth: 600,
            _thumbnailHeight: 130,
            _thumbnailTime: 1631622958847,
          },
          blockId: "Blank000Light",
        },
      ],
    },
    dataVersion: 0,
    collectionType: {
      id: "1",
      title: "Pages",
    },
    fields: [],
  },
  projectData: {
    selectedKit: "vnexmlshkihvcgsxmozgxzzdwsyvolvmhtne",
    selectedStyle: "kldugntsakdckzxhreidncqvgunudghrcuzv",
    styles: [
      {
        id: "kldugntsakdckzxhreidncqvgunudghrcuzv",
        title: "Default",
        colorPalette: [
          { id: "color1", hex: "#191b21" },
          { id: "color2", hex: "#142850" },
          { id: "color3", hex: "#239ddb" },
          { id: "color4", hex: "#66738d" },
          { id: "color5", hex: "#bde1f4" },
          { id: "color6", hex: "#eef0f2" },
          { id: "color7", hex: "#73777f" },
          { id: "color8", hex: "#ffffff" },
        ],
        fontStyles: [
          {
            deletable: "off",
            id: "paragraph",
            title: "Paragraph",
            fontFamily: "noto_serif",
            fontFamilyType: "google",
            fontSize: 16,
            fontSizeSuffix: "px",
            fontWeight: 300,
            lineHeight: 1.7,
            letterSpacing: 0,
            tabletFontSize: 15,
            tabletFontSizeSuffix: "px",
            tabletFontWeight: 300,
            tabletLineHeight: 1.6,
            tabletLetterSpacing: 0,
            mobileFontSize: 15,
            mobileFontSizeSuffix: "px",
            mobileFontWeight: 300,
            mobileLineHeight: 1.6,
            mobileLetterSpacing: 0,
          },
          {
            deletable: "off",
            id: "subtitle",
            title: "Subtitle",
            fontFamily: "noto_serif",
            fontFamilyType: "google",
            fontSize: 18,
            fontSizeSuffix: "px",
            fontWeight: 300,
            lineHeight: 1.5,
            letterSpacing: 0,
            tabletFontSize: 17,
            tabletFontSizeSuffix: "px",
            tabletFontWeight: 300,
            tabletLineHeight: 1.5,
            tabletLetterSpacing: 0,
            mobileFontSize: 17,
            mobileFontSizeSuffix: "px",
            mobileFontWeight: 300,
            mobileLineHeight: 1.5,
            mobileLetterSpacing: 0,
          },
          {
            deletable: "off",
            id: "abovetitle",
            title: "Above Title",
            fontFamily: "montserrat",
            fontFamilyType: "google",
            fontSize: 16,
            fontSizeSuffix: "px",
            fontWeight: 400,
            lineHeight: 1.7,
            letterSpacing: 2,
            tabletFontSize: 15,
            tabletFontSizeSuffix: "px",
            tabletFontWeight: 400,
            tabletLineHeight: 1.7,
            tabletLetterSpacing: 2,
            mobileFontSize: 13,
            mobileFontSizeSuffix: "px",
            mobileFontWeight: 400,
            mobileLineHeight: 1.7,
            mobileLetterSpacing: 2,
          },
          {
            deletable: "off",
            id: "heading1",
            title: "Heading 1",
            fontFamily: "montserrat",
            fontFamilyType: "google",
            fontSize: 56,
            fontSizeSuffix: "px",
            fontWeight: 200,
            lineHeight: 1.3,
            letterSpacing: -1.5,
            tabletFontSize: 40,
            tabletFontSizeSuffix: "px",
            tabletFontWeight: 200,
            tabletLineHeight: 1.3,
            tabletLetterSpacing: -1,
            mobileFontSize: 34,
            mobileFontSizeSuffix: "px",
            mobileFontWeight: 200,
            mobileLineHeight: 1.3,
            mobileLetterSpacing: -1,
          },
          {
            deletable: "off",
            id: "heading2",
            title: "Heading 2",
            fontFamily: "montserrat",
            fontFamilyType: "google",
            fontSize: 42,
            fontSizeSuffix: "px",
            fontWeight: 700,
            lineHeight: 1.3,
            letterSpacing: -1.5,
            tabletFontSize: 35,
            tabletFontSizeSuffix: "px",
            tabletFontWeight: 700,
            tabletLineHeight: 1.3,
            tabletLetterSpacing: -0.5,
            mobileFontSize: 29,
            mobileFontSizeSuffix: "px",
            mobileFontWeight: 700,
            mobileLineHeight: 1.3,
            mobileLetterSpacing: -0.5,
          },
          {
            deletable: "off",
            id: "heading3",
            title: "Heading 3",
            fontFamily: "montserrat",
            fontFamilyType: "google",
            fontSize: 32,
            fontSizeSuffix: "px",
            fontWeight: 600,
            lineHeight: 1.3,
            letterSpacing: -1,
            tabletFontSize: 27,
            tabletFontSizeSuffix: "px",
            tabletFontWeight: 600,
            tabletLineHeight: 1.3,
            tabletLetterSpacing: 0,
            mobileFontSize: 22,
            mobileFontSizeSuffix: "px",
            mobileFontWeight: 600,
            mobileLineHeight: 1.3,
            mobileLetterSpacing: 0,
          },
          {
            deletable: "off",
            id: "heading4",
            title: "Heading 4",
            fontFamily: "montserrat",
            fontFamilyType: "google",
            fontSize: 26,
            fontSizeSuffix: "px",
            fontWeight: 500,
            lineHeight: 1.4,
            letterSpacing: -1,
            tabletFontSize: 24,
            tabletFontSizeSuffix: "px",
            tabletFontWeight: 500,
            tabletLineHeight: 1.4,
            tabletLetterSpacing: 0,
            mobileFontSize: 21,
            mobileFontSizeSuffix: "px",
            mobileFontWeight: 500,
            mobileLineHeight: 1.4,
            mobileLetterSpacing: 0,
          },
          {
            deletable: "off",
            id: "heading5",
            title: "Heading 5",
            fontFamily: "montserrat",
            fontFamilyType: "google",
            fontSize: 20,
            fontSizeSuffix: "px",
            fontWeight: 500,
            lineHeight: 1.5,
            letterSpacing: 0,
            tabletFontSize: 19,
            tabletFontSizeSuffix: "px",
            tabletFontWeight: 500,
            tabletLineHeight: 1.4,
            tabletLetterSpacing: 0,
            mobileFontSize: 18,
            mobileFontSizeSuffix: "px",
            mobileFontWeight: 500,
            mobileLineHeight: 1.4,
            mobileLetterSpacing: 0,
          },
          {
            deletable: "off",
            id: "heading6",
            title: "Heading 6",
            fontFamily: "montserrat",
            fontFamilyType: "google",
            fontSize: 17,
            fontSizeSuffix: "px",
            fontWeight: 500,
            lineHeight: 1.5,
            letterSpacing: 0,
            tabletFontSize: 16,
            tabletFontSizeSuffix: "px",
            tabletFontWeight: 500,
            tabletLineHeight: 1.4,
            tabletLetterSpacing: 0,
            mobileFontSize: 16,
            mobileFontSizeSuffix: "px",
            mobileFontWeight: 500,
            mobileLineHeight: 1.4,
            mobileLetterSpacing: 0,
          },
          {
            deletable: "off",
            id: "button",
            title: "Button",
            fontFamily: "montserrat",
            fontFamilyType: "google",
            fontSize: 12,
            fontSizeSuffix: "px",
            fontWeight: 600,
            lineHeight: 1.8,
            letterSpacing: 3,
            tabletFontSize: 12,
            tabletFontSizeSuffix: "px",
            tabletFontWeight: 600,
            tabletLineHeight: 1.8,
            tabletLetterSpacing: 3,
            mobileFontSize: 12,
            mobileFontSizeSuffix: "px",
            mobileFontWeight: 600,
            mobileLineHeight: 1.8,
            mobileLetterSpacing: 3,
          },
        ],
      },
    ],
    extraFontStyles: [],
    font: "lato",
    fonts: {
      config: {
        data: [
          {
            kind: "webfonts#webfont",
            family: "Lato",
            category: "sans-serif",
            variants: [
              "100",
              "100italic",
              "300",
              "300italic",
              "regular",
              "italic",
              "700",
              "700italic",
              "900",
              "900italic",
            ],
            subsets: ["latin-ext", "latin"],
            version: "v15",
            lastModified: "2019-03-26",
            files: {
              100: "http://fonts.gstatic.com/s/lato/v15/S6u8w4BMUTPHh30wWyWrFCbw7A.ttf",
              300: "http://fonts.gstatic.com/s/lato/v15/S6u9w4BMUTPHh7USew-FGC_p9dw.ttf",
              700: "http://fonts.gstatic.com/s/lato/v15/S6u9w4BMUTPHh6UVew-FGC_p9dw.ttf",
              900: "http://fonts.gstatic.com/s/lato/v15/S6u9w4BMUTPHh50Xew-FGC_p9dw.ttf",
              "100italic": "http://fonts.gstatic.com/s/lato/v15/S6u-w4BMUTPHjxsIPy-vNiPg7MU0.ttf",
              "300italic": "http://fonts.gstatic.com/s/lato/v15/S6u_w4BMUTPHjxsI9w2PHA3s5dwt7w.ttf",
              regular: "http://fonts.gstatic.com/s/lato/v15/S6uyw4BMUTPHvxk6XweuBCY.ttf",
              italic: "http://fonts.gstatic.com/s/lato/v15/S6u8w4BMUTPHjxswWyWrFCbw7A.ttf",
              "700italic": "http://fonts.gstatic.com/s/lato/v15/S6u_w4BMUTPHjxsI5wqPHA3s5dwt7w.ttf",
              "900italic": "http://fonts.gstatic.com/s/lato/v15/S6u_w4BMUTPHjxsI3wiPHA3s5dwt7w.ttf",
            },
            brizyId: "uzrpsocdxtgrkbxjjxkchqcybpvpzsuvdlji",
          },
          {
            kind: "webfonts#webfont",
            family: "Overpass",
            category: "sans-serif",
            variants: [
              "100",
              "100italic",
              "200",
              "200italic",
              "300",
              "300italic",
              "regular",
              "italic",
              "600",
              "600italic",
              "700",
              "700italic",
              "800",
              "800italic",
              "900",
              "900italic",
            ],
            subsets: ["latin", "latin-ext"],
            version: "v4",
            lastModified: "2019-07-17",
            files: {
              100: "http://fonts.gstatic.com/s/overpass/v4/qFdB35WCmI96Ajtm81nGU97gxhcJk1s.ttf",
              200: "http://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81lqcv7K6BsAikI7.ttf",
              300: "http://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81kOcf7K6BsAikI7.ttf",
              600: "http://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81l6d_7K6BsAikI7.ttf",
              700: "http://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81kedv7K6BsAikI7.ttf",
              800: "http://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81kCdf7K6BsAikI7.ttf",
              900: "http://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81kmdP7K6BsAikI7.ttf",
              "100italic": "http://fonts.gstatic.com/s/overpass/v4/qFdD35WCmI96Ajtm81Gga7rqwjUMg1siNQ.ttf",
              "200italic": "http://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81GgaxbL4h8ij1I7LLE.ttf",
              "300italic": "http://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga3LI4h8ij1I7LLE.ttf",
              regular: "http://fonts.gstatic.com/s/overpass/v4/qFdH35WCmI96Ajtm82GiWdrCwwcJ.ttf",
              italic: "http://fonts.gstatic.com/s/overpass/v4/qFdB35WCmI96Ajtm81GgU97gxhcJk1s.ttf",
              "600italic": "http://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81GgawbO4h8ij1I7LLE.ttf",
              "700italic": "http://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga2LP4h8ij1I7LLE.ttf",
              "800italic": "http://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga37M4h8ij1I7LLE.ttf",
              "900italic": "http://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga1rN4h8ij1I7LLE.ttf",
            },
            brizyId: "qwhwsomltrpyogspgbomkxquvqsqfdlvcnfo",
          },
          {
            kind: "webfonts#webfont",
            family: "Red Hat Text",
            category: "sans-serif",
            variants: ["regular", "italic", "500", "500italic", "700", "700italic"],
            subsets: ["latin", "latin-ext"],
            version: "v1",
            lastModified: "2019-07-26",
            files: {
              500: "http://fonts.gstatic.com/s/redhattext/v1/RrQIbohi_ic6B3yVSzGBrMxYm4QIG-eFNVmULg.ttf",
              700: "http://fonts.gstatic.com/s/redhattext/v1/RrQIbohi_ic6B3yVSzGBrMxY04IIG-eFNVmULg.ttf",
              regular: "http://fonts.gstatic.com/s/redhattext/v1/RrQXbohi_ic6B3yVSzGBrMxgb60sE8yZPA.ttf",
              italic: "http://fonts.gstatic.com/s/redhattext/v1/RrQJbohi_ic6B3yVSzGBrMxQbacoMcmJPECN.ttf",
              "500italic": "http://fonts.gstatic.com/s/redhattext/v1/RrQKbohi_ic6B3yVSzGBrMxQbZ_cGO2BF1yELmgy.ttf",
              "700italic": "http://fonts.gstatic.com/s/redhattext/v1/RrQKbohi_ic6B3yVSzGBrMxQbZ-UHu2BF1yELmgy.ttf",
            },
            brizyId: "eytgthrgfzlrrzxlhynabspndabldgdbdjnm",
          },
          {
            kind: "webfonts#webfont",
            family: "DM Serif Text",
            category: "serif",
            variants: ["regular", "italic"],
            subsets: ["latin", "latin-ext"],
            version: "v3",
            lastModified: "2019-07-16",
            files: {
              regular: "http://fonts.gstatic.com/s/dmseriftext/v3/rnCu-xZa_krGokauCeNq1wWyafOPXHIJErY.ttf",
              italic: "http://fonts.gstatic.com/s/dmseriftext/v3/rnCw-xZa_krGokauCeNq1wWyWfGFWFAMArZKqQ.ttf",
            },
            brizyId: "pujmflqmocbjojknwlnidilgqedjzqftpnrv",
          },
          {
            kind: "webfonts#webfont",
            family: "Blinker",
            category: "sans-serif",
            variants: ["100", "200", "300", "regular", "600", "700", "800", "900"],
            subsets: ["latin", "latin-ext"],
            version: "v1",
            lastModified: "2019-07-26",
            files: {
              100: "http://fonts.gstatic.com/s/blinker/v1/cIf_MaFatEE-VTaP_E2hZEsCkIt9QQ.ttf",
              200: "http://fonts.gstatic.com/s/blinker/v1/cIf4MaFatEE-VTaP_OGARGEsnIJkWL4.ttf",
              300: "http://fonts.gstatic.com/s/blinker/v1/cIf4MaFatEE-VTaP_IWDRGEsnIJkWL4.ttf",
              600: "http://fonts.gstatic.com/s/blinker/v1/cIf4MaFatEE-VTaP_PGFRGEsnIJkWL4.ttf",
              700: "http://fonts.gstatic.com/s/blinker/v1/cIf4MaFatEE-VTaP_JWERGEsnIJkWL4.ttf",
              800: "http://fonts.gstatic.com/s/blinker/v1/cIf4MaFatEE-VTaP_ImHRGEsnIJkWL4.ttf",
              900: "http://fonts.gstatic.com/s/blinker/v1/cIf4MaFatEE-VTaP_K2GRGEsnIJkWL4.ttf",
              regular: "http://fonts.gstatic.com/s/blinker/v1/cIf9MaFatEE-VTaPxCmrYGkHgIs.ttf",
            },
            brizyId: "yhkoopjikembswaygkzktfmiiashwjcrvbxr",
          },
          {
            kind: "webfonts#webfont",
            family: "Aleo",
            category: "serif",
            variants: ["300", "300italic", "regular", "italic", "700", "700italic"],
            subsets: ["latin", "latin-ext"],
            version: "v3",
            lastModified: "2019-07-16",
            files: {
              300: "http://fonts.gstatic.com/s/aleo/v3/c4mg1nF8G8_syKbr9DVDno985KM.ttf",
              700: "http://fonts.gstatic.com/s/aleo/v3/c4mg1nF8G8_syLbs9DVDno985KM.ttf",
              "300italic": "http://fonts.gstatic.com/s/aleo/v3/c4mi1nF8G8_swAjxeDdJmq159KOnWA.ttf",
              regular: "http://fonts.gstatic.com/s/aleo/v3/c4mv1nF8G8_s8ArD0D1ogoY.ttf",
              italic: "http://fonts.gstatic.com/s/aleo/v3/c4mh1nF8G8_swAjJ1B9tkoZl_Q.ttf",
              "700italic": "http://fonts.gstatic.com/s/aleo/v3/c4mi1nF8G8_swAjxaDBJmq159KOnWA.ttf",
            },
            brizyId: "ucgecsrbcjkpsfctgzwsocokuydcdgiubroh",
          },
          {
            kind: "webfonts#webfont",
            family: "Nunito",
            category: "sans-serif",
            variants: [
              "200",
              "200italic",
              "300",
              "300italic",
              "regular",
              "italic",
              "600",
              "600italic",
              "700",
              "700italic",
              "800",
              "800italic",
              "900",
              "900italic",
            ],
            subsets: ["latin", "vietnamese", "latin-ext"],
            version: "v11",
            lastModified: "2019-07-22",
            files: {
              200: "http://fonts.gstatic.com/s/nunito/v11/XRXW3I6Li01BKofA-sekZuHJeTsfDQ.ttf",
              300: "http://fonts.gstatic.com/s/nunito/v11/XRXW3I6Li01BKofAnsSkZuHJeTsfDQ.ttf",
              600: "http://fonts.gstatic.com/s/nunito/v11/XRXW3I6Li01BKofA6sKkZuHJeTsfDQ.ttf",
              700: "http://fonts.gstatic.com/s/nunito/v11/XRXW3I6Li01BKofAjsOkZuHJeTsfDQ.ttf",
              800: "http://fonts.gstatic.com/s/nunito/v11/XRXW3I6Li01BKofAksCkZuHJeTsfDQ.ttf",
              900: "http://fonts.gstatic.com/s/nunito/v11/XRXW3I6Li01BKofAtsGkZuHJeTsfDQ.ttf",
              "200italic": "http://fonts.gstatic.com/s/nunito/v11/XRXQ3I6Li01BKofIMN5MZ-vNWz4PDWtj.ttf",
              "300italic": "http://fonts.gstatic.com/s/nunito/v11/XRXQ3I6Li01BKofIMN4oZOvNWz4PDWtj.ttf",
              regular: "http://fonts.gstatic.com/s/nunito/v11/XRXV3I6Li01BKof4MuyAbsrVcA.ttf",
              italic: "http://fonts.gstatic.com/s/nunito/v11/XRXX3I6Li01BKofIMOaETM_FcCIG.ttf",
              "600italic": "http://fonts.gstatic.com/s/nunito/v11/XRXQ3I6Li01BKofIMN5cYuvNWz4PDWtj.ttf",
              "700italic": "http://fonts.gstatic.com/s/nunito/v11/XRXQ3I6Li01BKofIMN44Y-vNWz4PDWtj.ttf",
              "800italic": "http://fonts.gstatic.com/s/nunito/v11/XRXQ3I6Li01BKofIMN4kYOvNWz4PDWtj.ttf",
              "900italic": "http://fonts.gstatic.com/s/nunito/v11/XRXQ3I6Li01BKofIMN4AYevNWz4PDWtj.ttf",
            },
            brizyId: "ppzycxqtiwtmjnfpbfluoynrnnfviuerjczz",
          },
          {
            kind: "webfonts#webfont",
            family: "Knewave",
            category: "display",
            variants: ["regular"],
            subsets: ["latin", "latin-ext"],
            version: "v8",
            lastModified: "2019-07-16",
            files: {
              regular: "http://fonts.gstatic.com/s/knewave/v8/sykz-yx0lLcxQaSItSq9-trEvlQ.ttf",
            },
            brizyId: "jojwyelvgkjknbgrosxcdphkpqfcczzdlcen",
          },
          {
            kind: "webfonts#webfont",
            family: "Palanquin",
            category: "sans-serif",
            variants: ["100", "200", "300", "regular", "500", "600", "700"],
            subsets: ["devanagari", "latin", "latin-ext"],
            version: "v5",
            lastModified: "2019-07-16",
            files: {
              100: "http://fonts.gstatic.com/s/palanquin/v5/9XUhlJ90n1fBFg7ceXwUEltI7rWmZzTH.ttf",
              200: "http://fonts.gstatic.com/s/palanquin/v5/9XUilJ90n1fBFg7ceXwUvnpoxJuqbi3ezg.ttf",
              300: "http://fonts.gstatic.com/s/palanquin/v5/9XUilJ90n1fBFg7ceXwU2nloxJuqbi3ezg.ttf",
              500: "http://fonts.gstatic.com/s/palanquin/v5/9XUilJ90n1fBFg7ceXwUgnhoxJuqbi3ezg.ttf",
              600: "http://fonts.gstatic.com/s/palanquin/v5/9XUilJ90n1fBFg7ceXwUrn9oxJuqbi3ezg.ttf",
              700: "http://fonts.gstatic.com/s/palanquin/v5/9XUilJ90n1fBFg7ceXwUyn5oxJuqbi3ezg.ttf",
              regular: "http://fonts.gstatic.com/s/palanquin/v5/9XUnlJ90n1fBFg7ceXwsdlFMzLC2Zw.ttf",
            },
            brizyId: "xnikbaszrjutnnfixmtprduwstoziivqiflp",
          },
          {
            kind: "webfonts#webfont",
            family: "Palanquin Dark",
            category: "sans-serif",
            variants: ["regular", "500", "600", "700"],
            subsets: ["devanagari", "latin", "latin-ext"],
            version: "v6",
            lastModified: "2019-07-16",
            files: {
              500: "http://fonts.gstatic.com/s/palanquindark/v6/xn76YHgl1nqmANMB-26xC7yuF8Z6ZW41fcvN2KT4.ttf",
              600: "http://fonts.gstatic.com/s/palanquindark/v6/xn76YHgl1nqmANMB-26xC7yuF8ZWYm41fcvN2KT4.ttf",
              700: "http://fonts.gstatic.com/s/palanquindark/v6/xn76YHgl1nqmANMB-26xC7yuF8YyY241fcvN2KT4.ttf",
              regular: "http://fonts.gstatic.com/s/palanquindark/v6/xn75YHgl1nqmANMB-26xC7yuF_6OTEo9VtfE.ttf",
            },
            brizyId: "gqzfchsrosvxegeymkyugyofaztsitibprrf",
          },
          {
            kind: "webfonts#webfont",
            family: "Roboto",
            category: "sans-serif",
            variants: [
              "100",
              "100italic",
              "300",
              "300italic",
              "regular",
              "italic",
              "500",
              "500italic",
              "700",
              "700italic",
              "900",
              "900italic",
            ],
            subsets: ["greek-ext", "latin", "cyrillic-ext", "vietnamese", "latin-ext", "greek", "cyrillic"],
            version: "v20",
            lastModified: "2019-07-24",
            files: {
              100: "http://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgWxPKTM1K9nz.ttf",
              300: "http://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5vAx05IsDqlA.ttf",
              500: "http://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9vAx05IsDqlA.ttf",
              700: "http://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlvAx05IsDqlA.ttf",
              900: "http://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtvAx05IsDqlA.ttf",
              "100italic": "http://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrIzcXLsnzjYk.ttf",
              "300italic": "http://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjARc9AMX6lJBP.ttf",
              regular: "http://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Me5WZLCzYlKw.ttf",
              italic: "http://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu52xPKTM1K9nz.ttf",
              "500italic": "http://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ABc9AMX6lJBP.ttf",
              "700italic": "http://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBhc9AMX6lJBP.ttf",
              "900italic": "http://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBBc9AMX6lJBP.ttf",
            },
            brizyId: "wrqenoprsynrjiyxmfoeuwqddlnomrxemeec",
          },
          {
            kind: "webfonts#webfont",
            family: "Oswald",
            category: "sans-serif",
            variants: ["200", "300", "regular", "500", "600", "700"],
            subsets: ["latin", "cyrillic-ext", "vietnamese", "latin-ext", "cyrillic"],
            version: "v24",
            lastModified: "2019-07-23",
            files: {
              200: "http://fonts.gstatic.com/s/oswald/v24/TK3_WkUHHAIjg75cFRf3bXL8LICs13FvgUFoZAaRliE.ttf",
              300: "http://fonts.gstatic.com/s/oswald/v24/TK3_WkUHHAIjg75cFRf3bXL8LICs169vgUFoZAaRliE.ttf",
              500: "http://fonts.gstatic.com/s/oswald/v24/TK3_WkUHHAIjg75cFRf3bXL8LICs18NvgUFoZAaRliE.ttf",
              600: "http://fonts.gstatic.com/s/oswald/v24/TK3_WkUHHAIjg75cFRf3bXL8LICs1y9ogUFoZAaRliE.ttf",
              700: "http://fonts.gstatic.com/s/oswald/v24/TK3_WkUHHAIjg75cFRf3bXL8LICs1xZogUFoZAaRliE.ttf",
              regular: "http://fonts.gstatic.com/s/oswald/v24/TK3_WkUHHAIjg75cFRf3bXL8LICs1_FvgUFoZAaRliE.ttf",
            },
            brizyId: "ehiobdhupkijoltxyucnkenojglortpsupmp",
          },
          {
            kind: "webfonts#webfont",
            family: "Oxygen",
            category: "sans-serif",
            variants: ["300", "regular", "700"],
            subsets: ["latin", "latin-ext"],
            version: "v9",
            lastModified: "2019-07-22",
            files: {
              300: "http://fonts.gstatic.com/s/oxygen/v9/2sDcZG1Wl4LcnbuCJW8Db2-4C7wFZQ.ttf",
              700: "http://fonts.gstatic.com/s/oxygen/v9/2sDcZG1Wl4LcnbuCNWgDb2-4C7wFZQ.ttf",
              regular: "http://fonts.gstatic.com/s/oxygen/v9/2sDfZG1Wl4Lcnbu6iUcnZ0SkAg.ttf",
            },
            brizyId: "gzhhqjoyiaozuhrmbylqeknkdaqtxfdynaqt",
          },
          {
            kind: "webfonts#webfont",
            family: "Playfair Display",
            category: "serif",
            variants: ["regular", "italic", "700", "700italic", "900", "900italic"],
            subsets: ["latin", "vietnamese", "latin-ext", "cyrillic"],
            version: "v15",
            lastModified: "2019-07-22",
            files: {
              700: "http://fonts.gstatic.com/s/playfairdisplay/v15/nuFlD-vYSZviVYUb_rj3ij__anPXBYf9pWkU5xxiJKY.ttf",
              900: "http://fonts.gstatic.com/s/playfairdisplay/v15/nuFlD-vYSZviVYUb_rj3ij__anPXBb__pWkU5xxiJKY.ttf",
              regular: "http://fonts.gstatic.com/s/playfairdisplay/v15/nuFiD-vYSZviVYUb_rj3ij__anPXPTvSgWE_-xU.ttf",
              italic: "http://fonts.gstatic.com/s/playfairdisplay/v15/nuFkD-vYSZviVYUb_rj3ij__anPXDTnYhUM66xV7PQ.ttf",
              "700italic":
                "http://fonts.gstatic.com/s/playfairdisplay/v15/nuFnD-vYSZviVYUb_rj3ij__anPXDTngOWwe4z5nNKaV_w.ttf",
              "900italic":
                "http://fonts.gstatic.com/s/playfairdisplay/v15/nuFnD-vYSZviVYUb_rj3ij__anPXDTngAW4e4z5nNKaV_w.ttf",
            },
            brizyId: "bvbbabnggnnjzvtleuwdrnfuvssxrgeovjan",
          },
          {
            kind: "webfonts#webfont",
            family: "Fira Sans",
            category: "sans-serif",
            variants: [
              "100",
              "100italic",
              "200",
              "200italic",
              "300",
              "300italic",
              "regular",
              "italic",
              "500",
              "500italic",
              "600",
              "600italic",
              "700",
              "700italic",
              "800",
              "800italic",
              "900",
              "900italic",
            ],
            subsets: ["greek-ext", "latin", "cyrillic-ext", "vietnamese", "latin-ext", "greek", "cyrillic"],
            version: "v10",
            lastModified: "2019-07-22",
            files: {
              100: "http://fonts.gstatic.com/s/firasans/v10/va9C4kDNxMZdWfMOD5Vn9IjOazP3dUTP.ttf",
              200: "http://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnWKnuQR37fF3Wlg.ttf",
              300: "http://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnPKruQR37fF3Wlg.ttf",
              500: "http://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnZKvuQR37fF3Wlg.ttf",
              600: "http://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnSKzuQR37fF3Wlg.ttf",
              700: "http://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnLK3uQR37fF3Wlg.ttf",
              800: "http://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnMK7uQR37fF3Wlg.ttf",
              900: "http://fonts.gstatic.com/s/firasans/v10/va9B4kDNxMZdWfMOD5VnFK_uQR37fF3Wlg.ttf",
              "100italic": "http://fonts.gstatic.com/s/firasans/v10/va9A4kDNxMZdWfMOD5VvkrCqYTfVcFTPj0s.ttf",
              "200italic": "http://fonts.gstatic.com/s/firasans/v10/va9f4kDNxMZdWfMOD5VvkrAGQBf_XljGllLX.ttf",
              "300italic": "http://fonts.gstatic.com/s/firasans/v10/va9f4kDNxMZdWfMOD5VvkrBiQxf_XljGllLX.ttf",
              regular: "http://fonts.gstatic.com/s/firasans/v10/va9E4kDNxMZdWfMOD5VfkILKSTbndQ.ttf",
              italic: "http://fonts.gstatic.com/s/firasans/v10/va9C4kDNxMZdWfMOD5VvkojOazP3dUTP.ttf",
              "500italic": "http://fonts.gstatic.com/s/firasans/v10/va9f4kDNxMZdWfMOD5VvkrA6Qhf_XljGllLX.ttf",
              "600italic": "http://fonts.gstatic.com/s/firasans/v10/va9f4kDNxMZdWfMOD5VvkrAWRRf_XljGllLX.ttf",
              "700italic": "http://fonts.gstatic.com/s/firasans/v10/va9f4kDNxMZdWfMOD5VvkrByRBf_XljGllLX.ttf",
              "800italic": "http://fonts.gstatic.com/s/firasans/v10/va9f4kDNxMZdWfMOD5VvkrBuRxf_XljGllLX.ttf",
              "900italic": "http://fonts.gstatic.com/s/firasans/v10/va9f4kDNxMZdWfMOD5VvkrBKRhf_XljGllLX.ttf",
            },
            brizyId: "wndeuiwznzaqgsugjnojbhzjhjwtryegciis",
          },
          {
            kind: "webfonts#webfont",
            family: "Abril Fatface",
            category: "display",
            variants: ["regular"],
            subsets: ["latin", "latin-ext"],
            version: "v11",
            lastModified: "2019-07-17",
            files: {
              regular: "http://fonts.gstatic.com/s/abrilfatface/v11/zOL64pLDlL1D99S8g8PtiKchm-BsjOLhZBY.ttf",
            },
            brizyId: "fbyhozjmiqseimmgxerwiucacmaaljqitrdc",
          },
          {
            kind: "webfonts#webfont",
            family: "Comfortaa",
            category: "display",
            variants: ["300", "regular", "500", "600", "700"],
            subsets: ["latin", "cyrillic-ext", "vietnamese", "latin-ext", "greek", "cyrillic"],
            version: "v23",
            lastModified: "2019-07-17",
            files: {
              300: "http://fonts.gstatic.com/s/comfortaa/v23/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4TbMPrQVIT9c2c8.ttf",
              500: "http://fonts.gstatic.com/s/comfortaa/v23/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4VrMPrQVIT9c2c8.ttf",
              600: "http://fonts.gstatic.com/s/comfortaa/v23/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4bbLPrQVIT9c2c8.ttf",
              700: "http://fonts.gstatic.com/s/comfortaa/v23/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4Y_LPrQVIT9c2c8.ttf",
              regular: "http://fonts.gstatic.com/s/comfortaa/v23/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4WjMPrQVIT9c2c8.ttf",
            },
            brizyId: "plspcdzrrelkhthvkmoocpwrtltvuzqcyraw",
          },
          {
            kind: "webfonts#webfont",
            family: "Kaushan Script",
            category: "handwriting",
            variants: ["regular"],
            subsets: ["latin", "latin-ext"],
            version: "v8",
            lastModified: "2019-07-17",
            files: {
              regular: "http://fonts.gstatic.com/s/kaushanscript/v8/vm8vdRfvXFLG3OLnsO15WYS5DF7_ytN3M48a.ttf",
            },
            brizyId: "simpmqjphttgbnwqaobwxuxoavrdlbpdjgzc",
          },
        ],
      },
    },
  },
  integrations: {
    form: {
      action: "https://reqbin.com/sample/post/json",
      fields: {
        handler(res) {
          res([
            {
              title: "Email",
              value: "email",
            },
            {
              title: "Name",
              value: "name",
            },
            {
              title: "Password",
              value: "password",
            },
          ]);
        },
      },
    },
  },
  pagePreview: "http://localhost:8001/preview",
};
